<template>
  <div class="sa">
    <el-steps
      :active="runNodes[runNodes.length - 1].state == 0 ? runNodes.length - 1 : runNodes.length"
      finish-status="success"
      simple
      :class="defNodes.length >= 8 ? 'steps steps-13' : 'steps'"
      v-if="defNodes.length"
    >
      <el-step :title="defNode.name" v-for="(defNode, i) in defNodes" :key="i"></el-step>
    </el-steps>
    <div class="box-detail">
      <div class="box-left">
        <div class="box-left-header">
          <!-- 导航注释 -->
          <!-- <div @click="$router.go(-1)" class="goBack c-position-static c-m-0">
            <i class="el-icon-arrow-left"></i>
            <span>工单</span>
            <i class="el-icon-s-claim"></i>
          </div> -->
          <!-- <div
            @click="$router.push({ path: '/ServiceAppointments' })"
            class="goBack c-position-static c-m-0"
          >
            <i class="el-icon-arrow-left"></i>
            <span>工单</span>
            <i class="el-icon-s-claim"></i>
          </div> -->

          <!-- <div>
            <el-tag
              :type="workflowNodeObj.state == 0 ? 'danger' : 'success'"
              effect="dark"
              class="c-m-r-10"
              v-if="workflowNodeObj.nodeDef.name"
            >
              {{ workflowNodeObj.nodeDef.name }}
            </el-tag>
          </div> -->
        </div>
        <div class="box-left-content">
          <c-form
            :formData="formData"
            :fields="extFields"
            :options="options"
            :requestOptions="requestOptions"
            ref="form"
            :upload="upload"
            labelWidth="100px"
            :area="area"
            @changeForm="osg.changeForm"
          >
            <template slot="inventoryId">
              <template v-if="formData._id">
                <el-input v-model="formData.exts.warrantyProductName" disabled></el-input>
              </template>
              <template v-else>
                <el-select
                  v-model="formData.exts.inventoryId"
                  @change="handleInventoryIdSelect"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in options.warrantyProductInventorys"
                    :key="item._id"
                    :label="item.name"
                    :value="item._id"
                  ></el-option>
                </el-select>
              </template>
            </template>
            <template slot="name">
              <el-autocomplete
                popper-class="my-autocomplete"
                v-model="formData.name"
                :fetch-suggestions="querySearch"
                placeholder="请输客户名称"
                @select="handleSelect"
                hide-loading
                value-key="name"
                :disabled="
                  extFields.some(
                    fiel =>
                      fiel.name == 'name' &&
                      (fiel.operationType == '2'
                        ? true
                        : fiel.operationType == '3'
                        ? formData._id
                          ? true
                          : false
                        : false)
                  )
                "
              >
                <i class="el-icon-search el-input__icon"></i>
                <template slot-scope="{ item }">
                  <p class="c-flex c-flex-between">
                    <span>{{ item.name }}</span>
                    <span>{{ item.phone }}</span>
                  </p>
                </template>
              </el-autocomplete>
            </template>
            <template slot="phone">
              <!-- 中间号 -->
              <el-popover
                v-if="privateNumber.show"
                placement="top-start"
                trigger="click"
                :content="privateNumber.phone"
              >
                <el-button
                  slot="reference"
                  class="c-w-1"
                  @click="
                    osg.getPrivateNumber(
                      '1',
                      null,
                      formData.contactIds && formData.contactIds[0],
                      formData._id
                    )
                  "
                >
                  查看中间号
                </el-button>
              </el-popover>
              <el-input
                v-model="formData.phone"
                :disabled="
                  extFields.some(
                    fiel =>
                      fiel.name == 'phone' &&
                      (fiel.operationType == '2'
                        ? true
                        : fiel.operationType == '3'
                        ? formData._id
                          ? true
                          : false
                        : false)
                  )
                "
                v-else
              ></el-input>
            </template>
            <template slot="landlineNumber">
              <!-- 中间号 -->
              <el-popover
                v-if="
                  privateNumber.show &&
                    (formData.exts.landlineNumber == '10000' ||
                      formData.exts.landlineNumber == '9999')
                "
                placement="top-start"
                trigger="click"
                :content="privateNumber.phone"
              >
                <el-button
                  slot="reference"
                  class="c-w-1"
                  @click="
                    osg.getPrivateNumber(
                      '8',
                      null,
                      formData.contactIds && formData.contactIds[0],
                      formData._id
                    )
                  "
                >
                  查看中间号
                </el-button>
              </el-popover>
              <el-input v-model="formData.exts.landlineNumber" v-else></el-input>
            </template>
            <template slot="area" v-if="tenantId == '1340835581184723420'">
              <el-cascader
                popper-class="cascaderLabelHide-wrapper"
                ref="areaSelector"
                :options="area.options"
                :props="{
                  expandTrigger: 'hover'
                }"
                v-model="formData.area"
                clearable
                @change="
                  if (formData.subdistrict) {
                    formData.subdistrict = '';
                  }
                  osg.getSubdistricts(formData.area, result => {
                    options.subdistricts = result;
                    $forceUpdate();
                  });
                "
              ></el-cascader>
            </template>
            <!-- <template slot="address">
              <el-input
                v-model="formData.address"
                suffix-icon="el-icon-map-location"
                @blur="getGeocode"
              ></el-input>
            </template> -->
            <!-- TODO:闭水用到了 -->
            <!-- <el-form-item label="工作类型" v-if="tenantId == '4551453470943235290'">
          <el-select v-model="formData.workType">
            <el-option
              v-for="item in options.workType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
            <template slot="channel">
              <el-cascader
                clearable
                v-model="formData.channel"
                :options="options.channel"
                :props="{ expandTrigger: 'hover', label: 'name' }"
              ></el-cascader>
            </template>
            <!-- <el-form-item label="获客渠道" v-if="formData.channelId">
          <el-select v-model="formData.channelId" :disabled="true">
            <el-option
              v-for="item in options.channelId"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
            <!-- <template slot="title21" v-if="tenantId == '4551453470943235290'">
              <el-input
                :disabled="formData._id"
                v-model="formData.exts['title21']"
                type="number"
                :placeholder="formData.placeholder || '请输入'"
              >
        </template> -->
            <template slot="title21" lot="title21" v-if="tenantId == '4551453470943235290'">
              <el-input
                :disabled="!!formData._id"
                v-model="formData.exts['title21']"
                type="number"
                :placeholder="formData.placeholder || '请输入'"
              ></el-input>
            </template>
          </c-form>
        </div>
        <div class="box-left-footer" v-has="'ServiceAppointment,save'">
          <el-button type="primary" @click="doSave('process')">提交</el-button>
          <el-button plain @click="getData">取消</el-button>
        </div>
      </div>
      <div class="box-center">
        <el-tabs v-model="activeTab" @tab-click="tabClick">
          <el-tab-pane label="业务动态" name="log">
            <div class="box-center-tool">
              <div>
                <el-date-picker
                  v-model="log.searchDate"
                  type="datetimerange"
                  style="width: 320px;"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
                  @change="getLog"
                  class="search-date"
                ></el-date-picker>
              </div>
              <div>
                <el-input
                  placeholder="请输入标题/内容"
                  v-model="log.searchValue"
                  class="search-input"
                  clearable
                  @clear="getLog"
                  @keyup.enter.native="getLog"
                >
                  <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
                </el-input>
              </div>
            </div>
            <div
              class="c-flex"
              style="justify-content: flex-end;padding: 0 10px;"
              v-if="osg.has('ServiceAppointment,patchingWorkflow')"
            >
              <el-button type="primary" @click="patchingWorkflow('patchingWorkflowFpgd')">
                补派工队节点处理
              </el-button>
              <el-button type="primary" @click="patchingWorkflow('patchingWorkflowSgxlc')">
                补施工小流程处理
              </el-button>
            </div>
            <div class="box-center-content">
              <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
                <div class="activity-card-header">
                  <span class="c-font-500">
                    <i class="el-icon-monitor c-w-30"></i>
                    {{ log.title }}
                  </span>
                  <span>{{ log.createTime }}</span>
                </div>

                <div v-if="log.extData && log.extData.length > 0" class="activity-card-content">
                  <!-- {{ log.content }} -->
                  <div class v-for="(sub, ui) in log.extData" :key="ui">
                    <div>{{ sub.name }} : {{ sub.value }}</div>
                  </div>
                </div>
                <div v-else class="activity-card-content">
                  {{ log.content || '' }}
                </div>
                <div class="activity-card-footer">
                  <span>操作人：{{ log.createUserName }}</span>
                  <el-button
                    title="查看错误日志"
                    icon="el-icon-s-release"
                    circle
                    v-if="
                      osg.has('ServiceAppointment,exception') &&
                        (log.exception || log.exceptionMsg || log.formData)
                    "
                    @click="
                      exception.exceptionMsg = log.exceptionMsg
                        ? log.exceptionMsg.replace(/(\r\n|\n|\r)/gm, '<br />')
                        : '';
                      exception.exception = log.exception
                        ? log.exception.replace(/(\r\n|\n|\r)/gm, '<br />')
                        : '';
                      exception.show = true;
                    "
                  ></el-button>
                </div>
              </div>
            </div>
            <el-dialog
              title="异常日志"
              :visible.sync="exception.show"
              style="margin-top: 10vh;"
              class="exception"
              @close="exception.show = false"
            >
              <div>
                <el-tabs v-model="exception.active">
                  <el-tab-pane label="exceptionMsg" name="exceptionMsg">
                    <div v-html="exception.exceptionMsg"></div>
                  </el-tab-pane>
                  <el-tab-pane label="exception" name="exception">
                    <div v-html="exception.exception"></div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <!-- <div slot="footer">
                  <el-button type="primary" @click="exception.show = false">确 认</el-button>
                </div> -->
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane
            label="业务跟踪"
            name="bizStackTraceSA"
            v-if="osg.has('ServiceAppointment,exception')"
          >
            <bizStackTrace :params="{ sid: id }" v-if="id"></bizStackTrace>
          </el-tab-pane>
          <el-tab-pane label="笔记" name="notes">
            <div class="box-center-tool">
              <div></div>
              <el-button
                type="primary"
                size="mini"
                @click="
                  vqeditor.content = ``;
                  openNote = true;
                "
              >
                创建笔记
              </el-button>
            </div>
            <div class="box-center-content">
              <div class="activity-card" v-for="(note, i) in noteData" :key="i">
                <div class="activity-card-header">
                  <span>
                    <i class="el-icon-edit-outline c-w-30"></i>
                    笔记
                  </span>
                  <span>{{ note.createTime }}</span>
                </div>
                <div
                  class="activity-card-content-node"
                  v-html="note.content"
                  v-if="!note.openNote"
                ></div>
                <c-editor
                  v-else
                  class="c-m-15"
                  :formData="note"
                  :value="'content'"
                  ref="editor"
                ></c-editor>
                <div class="activity-card-footer">
                  <span>操作人：{{ note.createUserName }}</span>
                </div>
              </div>
            </div>
            <!-- markdown编辑器 -->
            <el-dialog
              title="笔记"
              :visible.sync="openNote"
              style="margin-top: 10vh"
              @close="vqeditor.content = ''"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
            >
              <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
              <div slot="footer">
                <el-button type="primary" @click="saveNote">确 认</el-button>
                <el-button
                  @click="
                    openNote = false;
                    vqeditor.content = '';
                  "
                >
                  取 消
                </el-button>
              </div>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane label="跟进记录" name="record" v-if="osg.has('ServiceAppointment,record')">
            <div class="box-center-content">
              <div class="activity-card" v-for="(reco, i) in record.fpi.data" :key="i">
                <div class="activity-card-header">
                  <span>
                    <i class="el-icon-edit-outline c-w-30"></i>
                    跟进记录
                  </span>
                  <span>{{ reco.createTime }}</span>
                </div>
                <div class="activity-card-content">
                  <div class="c-flex" v-if="reco.serviceAppointmentOrderNum">
                    <span>工单编号：</span>
                    <span>{{ reco.serviceAppointmentOrderNum }}</span>
                  </div>
                  <div class="c-flex">
                    <span>通话状态：</span>
                    <span
                      v-text="
                        formatterCodelabel(
                          Array.isArray(reco.dedicateMode)
                            ? reco.dedicateMode.join(',')
                            : reco.dedicateMode,
                          'LEADSTATUS',
                          'cascade'
                        )
                      "
                    ></span>
                  </div>
                  <div v-if="reco.nextTime">
                    <span>下次联系时间：</span>
                    <span>{{ reco.nextTime }}</span>
                  </div>
                  <div v-if="reco.name">
                    <span>姓名：</span>
                    <span>{{ reco.name }}</span>
                  </div>
                  <div v-if="reco.phone">
                    <span>手机号：</span>
                    <span>{{ reco.phone }}</span>
                  </div>
                  <div v-if="reco.province">
                    <span>省：</span>
                    <span>{{ formatProvince(reco.province) || '' }}</span>
                  </div>
                  <div v-if="reco.city">
                    <span>市：</span>
                    <span>{{ formatCity(reco.city) || '' }}</span>
                  </div>
                  <div v-if="reco.district">
                    <span>区：</span>
                    <span>{{ formatDistrict(reco.district) || '' }}</span>
                  </div>
                  <div v-if="reco.address">
                    <span>地址：</span>
                    <span>{{ reco.address }}</span>
                  </div>
                  <div v-if="reco.channel">
                    <span>信息渠道：</span>
                    <span
                      v-text="
                        osg.formatCascade(
                          'channel',
                          osg.isJson(reco.channel) ? JSON.parse(reco.channel) : reco.channel
                        )
                      "
                    ></span>
                  </div>
                  <div v-if="reco.leakagesite">
                    <span>维修部位：</span>
                    <span
                      v-text="
                        osg.formatCascadeMultiple(
                          'repairParts',
                          osg.isJson(reco.leakagesite)
                            ? JSON.parse(reco.leakagesite)
                            : reco.leakagesite
                        )
                      "
                    ></span>
                  </div>

                  <div v-if="reco.memo">备注： {{ reco.memo }}</div>
                </div>
                <div class="activity-card-footer">
                  <span>操作人：{{ reco.createUserName }}</span>
                  <el-button
                    v-if="reco.callId"
                    icon="el-icon-view"
                    size="mini"
                    @click="viewCallRecord(reco.callId)"
                  >
                    查看通话记录
                  </el-button>
                </div>
              </div>
            </div>
            <el-dialog
              title="通话记录"
              id="callRecordDialog"
              :visible.sync="record.openCallRecord"
              @close="record.callData = {}"
            >
              <div class="box-center-content" style="border: 1px solid #ccc; border-radius: 6px">
                <div class="activity-card">
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-phone-outline c-w-30"></i>
                      <span v-if="record.callData.callDirection == '0'">呼入</span>
                      <span v-else-if="record.callData.callDirection == '1'">呼出</span>
                    </span>
                    <span v-if="record.callData.callWay == 4">
                      {{ formatMiddleCallResult(record.callData.middleCallResult) }}
                    </span>
                    <span v-else>{{ formatCallResult(record.callData.callResult) }}</span>
                  </div>
                  <div class="activity-card-content">
                    <div>
                      主叫：{{ record.callData.callerName }}
                      {{ record.callData.caller }}
                    </div>
                    <div>
                      被叫：{{
                        record.callData.callWay == 4
                          ? record.callData.calleeName || ''
                          : record.callData.callDirection == '0'
                          ? record.callData.calleeName || ''
                          : record.callData.calleeName || formData.name || ''
                      }}{{ ' ' + record.callData.callee }}
                    </div>
                    <div>
                      通话时间：{{ record.callData.startTimeStr }} 至
                      {{ record.callData.endTimeStr }}
                    </div>
                    <audio
                      v-if="record.callData.recordUrl"
                      class="c-m-t-15 w-1"
                      controls
                      :controlsList="
                        osg.has('ServiceAppointment,downloadAudio') ? null : 'nodownload'
                      "
                      @contextmenu.prevent="osg.has('ServiceAppointment,downloadAudio') ? true : ''"
                      :src="record.callData.recordUrl"
                    >
                      您的浏览器不支持 audio 标签。
                    </audio>
                  </div>
                  <div class="activity-card-footer">
                    <!-- <span>操作人：{{ item.createUserName }}</span> -->
                    <span></span>
                    <span>生成记录时间：{{ record.callData.createTime }}</span>
                  </div>
                </div>
              </div>
              <div slot="footer">
                <el-button
                  @click="
                    record.openCallRecord = false;
                    record.callData = {};
                  "
                >
                  关闭
                </el-button>
              </div>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane
            label="智齿通话记录"
            name="callRecords"
            v-if="osg.has('ServiceAppointment,callRecords')"
          >
            <div class="box-center-tool">
              <div>
                <el-date-picker
                  v-model="callRecords.searchDate"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
                  @change="getCallRecords"
                  class="search-date"
                ></el-date-picker>
              </div>
              <div>
                <el-input
                  placeholder="请输入主叫/被叫号码"
                  v-model="callRecords.searchValue"
                  class="search-input"
                  clearable
                  @clear="getCallRecords"
                  @keyup.enter.native="getCallRecords"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="getCallRecords"
                  ></el-button>
                </el-input>
              </div>
            </div>
            <div class="box-center-content">
              <div class="activity-card" v-for="(item, i) in callRecords.fpi.data" :key="i">
                <div class="activity-card-header">
                  <span class="c-font-500">
                    <i class="el-icon-phone-outline c-w-30"></i>
                    <span v-if="item.callDirection == '0'">呼入</span>
                    <span v-else-if="item.callDirection == '1'">呼出</span>
                  </span>
                  <span v-if="item.callWay == 4">
                    {{ formatMiddleCallResult(item.callResult) }}
                  </span>
                  <span v-else>{{ formatCallResult(item.callResult) }}</span>
                </div>
                <div class="activity-card-content">
                  <div>主叫：{{ item.callerName }} {{ item.caller }}</div>
                  <div>
                    被叫：{{
                      item.callWay == 4
                        ? item.calleeName || ''
                        : item.callDirection == '0'
                        ? item.calleeName || ''
                        : item.calleeName || formData.name || ''
                    }}{{ ' ' + (item.callee || '') }}
                  </div>
                  <div>通话时间：{{ item.startTimeStr }} 至 {{ item.endTimeStr }}</div>
                  <audio
                    v-if="item.recordUrl"
                    class="c-m-t-15"
                    controls
                    :controlsList="
                      osg.has('ServiceAppointment,downloadAudio') ? null : 'nodownload'
                    "
                    @contextmenu.prevent="osg.has('ServiceAppointment,downloadAudio') ? true : ''"
                    :src="item.recordUrl"
                  >
                    您的浏览器不支持 audio 标签。
                  </audio>
                </div>
                <div class="activity-card-footer">
                  <span></span>
                  <span>生成记录时间：{{ item.createTime }}</span>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane
            label="udesk通话记录"
            name="UDcallRecords"
            v-if="osg.has('ServiceAppointment,UDcallRecords')"
          >
            <!-- <div class="box-center-tool">
              <div>
                <el-date-picker
                  v-model="UDcallRecords.searchDate"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
                  @change="getUDcallRecords"
                  class="search-date"
                ></el-date-picker>
              </div>
              <div>
                <el-input
                  placeholder="请输入主叫/被叫号码"
                  v-model="UDcallRecords.searchValue"
                  class="search-input"
                  clearable
                  @clear="getUDcallRecords"
                  @keyup.enter.native="getUDcallRecords"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="getUDcallRecords"
                  ></el-button>
                </el-input>
              </div>
            </div> -->
            <div class="box-center-content">
              <div class="activity-card" v-for="(item, i) in UDcallRecords.fpi.data" :key="i">
                <div class="activity-card-header">
                  <span class="c-font-500">
                    <i class="el-icon-phone-outline c-w-30"></i>
                    <span>{{ item.call_type }}</span>
                    <!-- <span v-if="item.callDirection == '0'">呼入</span>
                    <span v-else-if="item.callDirection == '1'">呼出</span> -->
                  </span>
                  <!-- <span v-if="item.callWay == 4">
                    {{ formatMiddleCallResult(item.callResult) }}
                  </span>
                  <span v-else>{{ formatCallResult(item.callResult) }}</span> -->
                </div>
                <div class="activity-card-content">
                  <!-- <div>主叫：{{ item.callerName }} {{ item.caller }}</div>
                  <div>
                    被叫：{{
                      item.callWay == 4
                        ? item.calleeName || ''
                        : item.callDirection == '0'
                        ? item.calleeName || ''
                        : item.calleeName || formData.name || ''
                    }}{{ ' ' + (item.callee || '') }}
                  </div> -->
                  <div>客服姓名：{{ item.agent_name }}</div>
                  <div>通话时间：{{ item.start_time }} 至 {{ item.end_time }}</div>
                  <audio
                    v-if="item.fsgoRecordUrl"
                    class="c-m-t-15"
                    controls
                    :controlsList="
                      osg.has('ServiceAppointment,downloadAudio') ? null : 'nodownload'
                    "
                    @contextmenu.prevent="osg.has('ServiceAppointment,downloadAudio') ? true : ''"
                    :src="item.fsgoRecordUrl"
                  >
                    您的浏览器不支持 audio 标签。
                  </audio>
                </div>
                <div class="activity-card-footer">
                  <span></span>
                  <span>生成记录时间：{{ item.createTime }}</span>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="操作记录" name="history">
            <div
              class="box-center-content"
              v-infinite-scroll="getHistory"
              :infinite-scroll-immediate="true"
            >
              <c-modify
                :historyFpi="historyFpi"
                :fields="extFields"
                :fieldsObj="fieldsObj"
                :options="options"
                ref="modify"
              ></c-modify>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务步骤" name="steps">
            <div class="box-center-tool">
              <div></div>
            </div>
            <div class="box-center-content">
              <template v-for="(step, i) in stepList">
                <div
                  class="activity-card"
                  v-if="step.nodeDef && step.nodeDef.nodeType != 'subflows'"
                  :key="i"
                >
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-finished c-w-30"></i>
                      {{ step.nodeDef.name || step.name }}
                    </span>
                    <span>{{ step.createTime || step.nodeDef.createTime }}</span>
                  </div>
                  <div class="activity-card-content">
                    <div>
                      {{ step.nodeDef.desc || step.nodeDef.title }}
                    </div>
                  </div>
                  <div v-if="false" class="activity-card-content">
                    {{ log.content || '' }}
                  </div>
                  <div class="activity-card-footer">
                    <span>操作人：{{ step.updateUserName || step.nodeDef.updateUserName }}</span>
                    <el-button
                      @click.native.prevent="
                        seeSteps(step, null, step.nodeDef.nodeType);
                        stepNode = step;
                      "
                      size="mini"
                      v-if="
                        (step.nodeDef && step.nodeDef.formDefId) ||
                          step.nodeDef.workflowNodeList ||
                          step.nodeDef.nodeType == 'repeat'
                      "
                    >
                      查看
                    </el-button>
                  </div>
                </div>
              </template>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="box-right" :class="collapse ? 'box-collapse' : ''">
        <div class="box-right-header">
          <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
          <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
        </div>
        <div class="box-right-content" v-show="!collapse">
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <template slot="title">
                <span>线索</span>
                <!-- <el-button type="text" icon="el-icon-plus" @click.stop="newLead">
                添加线索
              </el-button> -->
              </template>
              <div class="card-group">
                <div class="card-item" v-for="(item, i) of lead.relatedData" :key="i">
                  <div>
                    <i class="el-icon-s-custom card-item-logo" style="color: #606266"></i>
                  </div>
                  <div>
                    <p v-if="item.phone">
                      <el-link @click="osg.open('', '', '_blank', '/Lead/' + item._id)">
                        {{ item.name }}
                      </el-link>
                    </p>
                    <p v-else>{{ item.name }}</p>
                    <p></p>
                  </div>
                  <!-- <i class="el-icon-close card-item-icon-remove" @click="removeLead(item)"></i>
                <i class="el-icon-edit card-item-icon-edit" @click="editLead(item)"></i> -->
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <span>客户</span>
                <el-button
                  type="text"
                  icon="el-icon-plus"
                  @click.stop="newContact"
                  v-if="tenantId != '1340835581184723420'"
                >
                  添加客户
                </el-button>
              </template>
              <div class="card-group">
                <div class="card-item" v-for="(item, i) of contact.relatedData" :key="i">
                  <div>
                    <i class="el-icon-s-custom card-item-logo" style="color: #606266"></i>
                  </div>
                  <div>
                    <p v-if="item.phone">
                      <el-link @click="osg.open('', '', '_blank', '/Contact/' + item._id)">
                        {{ item.name }}
                      </el-link>
                    </p>
                    <p v-else>
                      {{ item.name }}
                    </p>
                    <p v-if="item.phone">
                      <el-link :href="'tel:' + item.phone" target="_blank">
                        <i class="el-icon-phone-outline"></i>
                        {{ item.phone }}
                      </el-link>
                    </p>
                    <p v-if="item.email">
                      <el-link :href="'mailto:' + item.email" target="_blank">
                        <i class="el-icon-message"></i>
                        {{ item.email }}
                      </el-link>
                    </p>
                  </div>
                  <!-- <i
                    v-if="item.phone"
                    class="el-icon-close card-item-icon-remove"
                    @click="removeContact(item)"
                  ></i> -->
                  <i
                    v-if="item.phone"
                    class="el-icon-edit card-item-icon-edit"
                    @click="editContact(item)"
                  ></i>
                </div>
              </div>
            </el-collapse-item>
            <!-- <el-collapse-item name="3">
            <template slot="title">
              <span>公司</span>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click.stop="newCompany"
                v-if="company.relatedData.length == 0"
              >
                添加公司
              </el-button>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="1个工单只允许关联1个公司"
                placement="top-end"
              >
                <i class="el-icon-info c-color-primary"></i>
              </el-tooltip>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of company.relatedData" :key="i">
                <div>
                  <i class="el-icon-office-building card-item-logo"></i>
                </div>
                <div> 
                  <p>
                    <el-link @click="osg.open('', '', '_blank', '/Company/' + item._id)">
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p class="card-item-link">
                    <el-link :href="item.website" target="_blank">{{ item.domainName }}</el-link>
                  </p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="removeCompany(item)"></i>
                <i class="el-icon-edit card-item-icon-edit" @click="editCompany(item)"></i>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="4">
            <template slot="title">
              <span>地址</span>
              <el-button type="text" icon="el-icon-plus" @click.stop="newAddress">
                添加地址
              </el-button>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of address.relatedData" :key="i">
                <div>
                  <i class="el-icon-location-information card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link @click="osg.open('', '', '_blank', '/Address/' + item._id)">
                      {{ item.address }}
                    </el-link>
                  </p>
                  <p></p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="removeAddress(item)"></i>
                <i class="el-icon-edit card-item-icon-edit" @click="editAddress(item)"></i>
              </div>
            </div>
          </el-collapse-item> -->
            <el-collapse-item name="5">
              <template slot="title">
                <span>订单信息</span>
                <!-- <el-button type="text" icon="el-icon-plus" @click.stop="newOrder">添加订单</el-button> -->
              </template>
              <div class="card-group">
                <div class="card-item" v-for="(item, i) of order.relatedData" :key="i">
                  <div>
                    <i class="el-icon-s-order card-item-logo" style="color: #606266"></i>
                  </div>
                  <div>
                    <p>订单编号：{{ item._id }}</p>
                    <p>
                      总金额：
                      <span class="c_red">¥ {{ item.totalPrice }}</span>
                    </p>
                    <p>支付状态：{{ formatPayState(null, null, item.payState) }}</p>
                    <p v-if="item.exts.bjdPDFurl">
                      <el-link :href="item.exts.bjdPDFurl" target="_blank" type="primary">
                        查看报价单
                      </el-link>
                    </p>
                  </div>
                  <!--<i
                  class="el-icon-close card-item-icon-remove"
                  @click="editOrder(item)"
                ></i>-->
                  <i class="el-icon-view card-item-icon-edit" @click="editOrder(item)"></i>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="7" v-if="osg.has('ServiceAppointment,contractBlock')">
              <template slot="title">
                <span>合同</span>
                <!-- <el-button
                  type="text"
                  icon="el-icon-plus"
                  @click.stop="newContact"
                >
                  添加客户
                </el-button> -->
              </template>
              <div class="card-group">
                <div class="card-item" v-for="(item, i) of contract.relatedData" :key="i">
                  <div>
                    <i class="el-icon-document card-item-logo" style="color: #606266"></i>
                  </div>
                  <div>
                    <p v-if="item.contractdocNum">
                      <el-link @click="osg.open('', '', '_blank', '/Contract/' + item._id)">
                        合同编号：{{ item.contractdocNum }}
                      </el-link>
                    </p>
                    <p v-if="item.contactsName">委托方：{{ item.contactsName }}</p>
                    <p v-if="item.contactsPhone">手机号：{{ item.contactsPhone }}</p>
                    <p>
                      合同状态：{{
                        osg.codelabel(
                          'contractStatus',
                          (item.exts && item.exts.contractStatus) || ''
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="6" v-if="osg.has('ServiceAppointment,afterSaleBlock')">
              <template slot="title">
                <span>售后工单</span>
              </template>
              <div class="card-group">
                <div class="card-item" v-for="(item, i) of afterSaleSA.relatedData" :key="i">
                  <div>
                    <i class="el-icon-tickets card-item-logo"></i>
                  </div>
                  <div>
                    <p>
                      姓名:
                      <el-link
                        @click="
                          osg.open(
                            '',
                            '',
                            '_blank',
                            '/AfterSaleServiceAppointment/' + item._id + '?colName=workflowAlert'
                          )
                        "
                      >
                        {{ item.exts.nameAfterSaleSA }}
                      </el-link>
                    </p>
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="8">
              <template slot="title">
                <span>质保</span>
              </template>
              <div class="card-group">
                <div class="card-item" v-for="(item, i) of warranty.relatedData" :key="i">
                  <div>
                    <i class="el-icon-tickets card-item-logo"></i>
                  </div>
                  <div>
                    <p>
                      委托方:
                      <el-link
                        @click="
                          osg.open(
                            '',
                            '',
                            '_blank',
                            `/Warranty/${item.extId}?warrantyId=${item._id}`
                          )
                        "
                        target="_blank"
                      >
                        {{ item.fileName }}
                      </el-link>
                    </p>
                    <p>手机号: {{ item.ownerPhone }}</p>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!--关联/添加客户-->
        <el-drawer
          custom-class="c-drawer"
          title="添加客户"
          :visible.sync="contact.openRelate"
          direction="rtl"
          :wrapperClosable="false"
          :close-on-press-escape="false"
        >
          <div class="el-drawer__content">
            <el-tabs v-model="contact.activeName" type="card">
              <el-tab-pane label="选择已有客户" name="search">
                <p class="c-m-b-10 c-font-13">请输入客户姓名/手机号进行搜索</p>
                <el-select
                  v-model="formData.contactIds"
                  filterable
                  multiple
                  remote
                  reserve-keyword
                  placeholder
                  :remote-method="getContactData"
                  clearable
                  @clear="getContactData"
                  :loading="false"
                  @change="$forceUpdate()"
                  class="c-w-1"
                >
                  <el-option
                    v-for="item in contact.data"
                    :key="item._id"
                    :label="item.name"
                    :value="item._id"
                  >
                    <span class="c-fl">{{ item.name }}</span>
                    <span class="c-fr c-font-13">{{ item.phone }}</span>
                  </el-option>
                </el-select>
              </el-tab-pane>
              <el-tab-pane label="新建客户" name="create">
                <el-form
                  :model="contact.formData"
                  :rules="rules"
                  ref="contactFormData"
                  label-width="90px"
                  label-position="left"
                  hide-required-asterisk
                >
                  <el-form-item label="姓名" prop="name">
                    <el-input v-model="contact.formData.name" suffix-icon="el-icon-user"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号" prop="phone">
                    <el-input
                      v-model="contact.formData.phone"
                      suffix-icon="el-icon-mobile-phone"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="邮箱" prop="email">
                    <el-input
                      v-model="contact.formData.email"
                      suffix-icon="el-icon-message"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="地址" prop="address">
                    <el-input
                      v-model="contact.formData.address"
                      suffix-icon="el-icon-map-location"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="状态" prop="leadStatus">
                    <el-select v-model="contact.formData.leadStatus">
                      <el-option
                        v-for="item in options.leadStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="阶段" prop="lifecycleStage">
                    <el-select v-model="contact.formData.lifecycleStage">
                      <el-option
                        v-for="item in options.lifecycleStage"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="el-drawer__footer" v-if="contact.activeName == 'search'">
            <el-button
              type="primary"
              @click="
                doSave();
                initContact();
              "
            >
              保存
            </el-button>
            <el-button plain @click="initContact">取消</el-button>
          </div>
          <div class="el-drawer__footer" v-if="contact.activeName == 'create'">
            <el-button type="primary" @click="saveContact()">保存</el-button>
            <el-button plain @click="initContact">取消</el-button>
          </div>
        </el-drawer>
        <!--编辑客户-->
        <el-drawer
          custom-class="c-drawer"
          title="编辑客户"
          :visible.sync="contact.openEdit"
          direction="rtl"
          :wrapperClosable="false"
          :close-on-press-escape="false"
        >
          <div class="el-drawer__content">
            <el-form
              :model="contact.formData"
              :rules="rules"
              ref="contactFormData"
              label-width="90px"
              label-position="left"
              hide-required-asterisk
            >
              <el-form-item label="姓名" prop="name">
                <el-input v-model="contact.formData.name" suffix-icon="el-icon-user"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                <!-- 中间号 -->
                <el-popover
                  v-if="privateNumber.show"
                  placement="top-start"
                  trigger="click"
                  :content="privateNumber.phone"
                >
                  <el-button
                    slot="reference"
                    class="c-w-1"
                    @click="osg.getPrivateNumber('1', null, contact.formData._id, null)"
                  >
                    查看中间号
                  </el-button>
                </el-popover>
                <el-input
                  v-else
                  v-model="contact.formData.phone"
                  suffix-icon="el-icon-mobile-phone"
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="contact.formData.email" suffix-icon="el-icon-message"></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="address">
                <el-input
                  v-model="contact.formData.address"
                  suffix-icon="el-icon-map-location"
                ></el-input>
              </el-form-item>
              <el-form-item label="状态" prop="leadStatus">
                <el-select v-model="contact.formData.leadStatus">
                  <el-option
                    v-for="item in options.leadStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="阶段" prop="lifecycleStage">
                <el-select v-model="contact.formData.lifecycleStage">
                  <el-option
                    v-for="item in options.lifecycleStage"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="el-drawer__footer">
            <el-button type="primary" @click="saveContact()">保存</el-button>
            <el-button plain @click="initContact()">取消</el-button>
          </div>
        </el-drawer>
        <!--关联/添加公司-->
        <el-drawer
          custom-class="c-drawer"
          title="添加公司"
          :visible.sync="company.openRelate"
          direction="rtl"
          :wrapperClosable="false"
          :close-on-press-escape="false"
        >
          <div class="el-drawer__content">
            <el-tabs v-model="company.activeName" type="card">
              <el-tab-pane label="选择已有公司" name="search">
                <p class="c-m-b-10 c-font-13">请输入公司名称/负责人名称进行搜索</p>
                <el-select
                  v-model="formData.companyId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder
                  suffix-icon="el-icon-date"
                  :remote-method="getCompanyData"
                  clearable
                  @clear="getCompanyData"
                  :loading="false"
                  @change="$forceUpdate()"
                  class="c-w-1"
                >
                  <el-option
                    v-for="item in company.data"
                    :key="item._id"
                    :label="item.name"
                    :value="item._id"
                  ></el-option>
                </el-select>
              </el-tab-pane>
              <el-tab-pane label="新建公司" name="create">
                <el-form
                  :model="company.formData"
                  :rules="rules"
                  ref="companyFormData"
                  label-width="70px"
                  label-position="left"
                  hide-required-asterisk
                >
                  <el-form-item label="名称" prop="name">
                    <el-input v-model="company.formData.name"></el-input>
                  </el-form-item>
                  <el-form-item label="公司编号" prop="accountNumber">
                    <el-input v-model="company.formData.accountNumber"></el-input>
                  </el-form-item>
                  <el-form-item label="行业" prop="industry">
                    <el-select v-model="company.formData.industry">
                      <el-option
                        v-for="item in options.industry"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="联系电话">
                    <el-input v-model="company.formData.phone"></el-input>
                  </el-form-item>
                  <el-form-item label="客户ID">
                    <el-input v-model="company.formData.ownerId"></el-input>
                  </el-form-item>
                  <el-form-item label="类型">
                    <el-select v-model="company.formData.type">
                      <el-option
                        v-for="item in options.companytype"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="描述">
                    <el-input v-model="company.formData.description"></el-input>
                  </el-form-item>
                  <el-form-item label="网址" prop="website">
                    <el-input v-model="company.formData.website"></el-input>
                  </el-form-item>
                  <el-form-item label="域名" prop="domainName">
                    <el-input v-model="company.formData.domainName"></el-input>
                  </el-form-item>
                  <el-form-item label="成立时间" prop="foundTime">
                    <el-date-picker
                      v-model="company.formData.foundTime"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="el-drawer__footer" v-if="company.activeName == 'search'">
            <el-button
              type="primary"
              @click="
                doSave();
                initCompany();
              "
            >
              保存
            </el-button>
            <el-button
              plain
              @click="
                getData();
                initCompany();
              "
            >
              取消
            </el-button>
          </div>
          <div class="el-drawer__footer" v-if="company.activeName == 'create'">
            <el-button
              type="primary"
              @click="
                saveCompany();
                initCompany();
              "
            >
              保存
            </el-button>
            <el-button plain @click="initCompany">取消</el-button>
          </div>
        </el-drawer>
        <!--编辑公司-->
        <el-drawer
          custom-class="c-drawer"
          title="编辑公司"
          :visible.sync="company.openEdit"
          direction="rtl"
          :wrapperClosable="false"
          :close-on-press-escape="false"
        >
          <div class="el-drawer__content">
            <el-form
              :model="company.formData"
              :rules="rules"
              ref="companyFormData"
              label-width="70px"
              label-position="left"
              hide-required-asterisk
            >
              <el-form-item label="名称" prop="name">
                <el-input v-model="company.formData.name"></el-input>
              </el-form-item>
              <el-form-item label="公司编号" prop="accountNumber">
                <el-input v-model="company.formData.accountNumber"></el-input>
              </el-form-item>
              <el-form-item label="行业" prop="industry">
                <el-select v-model="company.formData.industry">
                  <el-option
                    v-for="item in options.industry"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="company.formData.phone"></el-input>
              </el-form-item>
              <el-form-item label="客户ID">
                <el-input v-model="company.formData.ownerId"></el-input>
              </el-form-item>
              <el-form-item label="类型">
                <el-select v-model="company.formData.type">
                  <el-option
                    v-for="item in options.companytype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="描述">
                <el-input v-model="company.formData.description"></el-input>
              </el-form-item>
              <el-form-item label="网址" prop="website">
                <el-input v-model="company.formData.website"></el-input>
              </el-form-item>
              <el-form-item label="域名" prop="domainName">
                <el-input v-model="company.formData.domainName"></el-input>
              </el-form-item>
              <el-form-item label="成立时间" prop="foundTime">
                <el-date-picker
                  v-model="company.formData.foundTime"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="el-drawer__footer">
            <el-button
              type="primary"
              @click="
                saveCompany();
                initCompany();
              "
            >
              保存
            </el-button>
            <el-button plain @click="initCompany()">取消</el-button>
          </div>
        </el-drawer>
        <!--添加/编辑地址-->
        <el-drawer
          custom-class="c-drawer"
          title="地址信息"
          :visible.sync="address.openEdit"
          direction="rtl"
          :wrapperClosable="false"
          :close-on-press-escape="false"
        >
          <div class="el-drawer__content">
            <el-form
              :model="address.formData"
              :rules="rules"
              ref="addressFormData"
              label-width="110px"
              label-position="left"
              hide-required-asterisk
            >
              <el-form-item label="地址" prop="address">
                <el-input v-model="address.formData.address"></el-input>
              </el-form-item>
              <el-form-item label="地址类型" prop="addressType">
                <el-select v-model="address.formData.addressType">
                  <el-option
                    v-for="item in options.addressType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.value != '2'"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="地址说明" prop="addressDescription">
                <el-input v-model="address.formData.addressDescription"></el-input>
              </el-form-item>
              <el-form-item label="地理编码准确度" prop="accuracy">
                <el-input v-model="address.formData.accuracy"></el-input>
              </el-form-item>
              <el-form-item label="经度" prop="longitude">
                <el-input
                  v-model="address.formData.longitude"
                  suffix-icon="el-icon-map-location"
                ></el-input>
              </el-form-item>
              <el-form-item label="纬度" prop="dimension">
                <el-input
                  v-model="address.formData.dimension"
                  suffix-icon="el-icon-map-location"
                ></el-input>
              </el-form-item>
              <el-form-item label="位置类型" prop="locationType">
                <el-select v-model="address.formData.locationType">
                  <el-option
                    v-for="item in options.locationType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="邮编" prop="zipCode">
                <el-input
                  v-model="address.formData.zipCode"
                  suffix-icon="el-icon-map-location"
                ></el-input>
              </el-form-item>
              <el-form-item label="国家" prop="country">
                <el-input
                  v-model="address.formData.country"
                  suffix-icon="el-icon-map-location"
                ></el-input>
              </el-form-item>
              <el-form-item label="省市区" prop="area">
                <el-cascader
                  :options="area.options"
                  :props="area.props"
                  v-model="address.formData.area"
                  collapse-tags
                  clearable
                ></el-cascader>
              </el-form-item>
              <el-form-item label="街道地址" prop="streetName">
                <el-input
                  v-model="address.formData.streetName"
                  suffix-icon="el-icon-map-location"
                ></el-input>
              </el-form-item>
              <el-form-item label="时区" prop="timeZone">
                <el-input
                  v-model="address.formData.timeZone"
                  suffix-icon="el-icon-map-location"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="el-drawer__footer">
            <el-button type="primary" @click="saveAddress">保存</el-button>
            <el-button plain @click="initAddress">取消</el-button>
          </div>
        </el-drawer>
        <!--添加/查看订单-->
        <el-drawer
          custom-class="c-drawer"
          title="订单信息"
          :visible.sync="order.openEdit"
          direction="rtl"
          size="700px !important"
          :wrapperClosable="false"
          :close-on-press-escape="false"
        >
          <div class="el-drawer__content" :class="order.openType != 'new' ? 'c-pointer-n' : ''">
            <el-button
              type="primary"
              @click="getProduct"
              class="c-m-b-10"
              v-if="order.openType == 'new'"
            >
              选择产品
            </el-button>
            <el-table :data="compute.items" style="width: 100%" height="calc(100% - 210px)">
              <el-table-column prop="name" label="产品名称" show-overflow-tooltip></el-table-column>
              <el-table-column label="单价" width="100px">
                <template slot-scope="scope">
                  ¥ {{ scope.row.price }}
                </template>
              </el-table-column>
              <el-table-column prop="number" label="数量" width="153px">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.number"
                    :min="0"
                    :precision="2"
                    size="mini"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                prop="unit"
                label="单位"
                width="50px"
                :formatter="formatUnit"
              ></el-table-column>
              <el-table-column label="小计" width="100px">
                <template slot-scope="scope">
                  ¥
                  {{ Number(scope.row.price) * Number(scope.row.number || 0) }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px">
                <template slot-scope="scope">
                  <el-button type="text" @click="removeItem(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="c-m-t-10" style="height: 150px">
              <el-form ref="orderFormData" :model="order" label-width="140px" label-position="left">
                <!-- <el-form-item label="其他费用(元)">
                <el-input-number
                  v-model.number="compute.otherAmount"
                  :min="0"
                  :controls="false"
                  :precision="2"
                ></el-input-number>
              </el-form-item> -->
                <el-form-item label="折扣">
                  <el-select v-model="compute.discount">
                    <el-option
                      v-for="item in options.discount"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="优惠金额/减去(元)">
                  <el-input-number
                    v-model.number="compute.preferentialAmount"
                    :min="0"
                    :max="compute.originPrice"
                    :controls="false"
                    :precision="2"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="款项备注">
                  <el-input
                    type="textarea"
                    v-model="order.description"
                    placeholder="如有其他费用，请在此备注费用内容。"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="el-drawer__footer c-flex-between">
            <div>
              总金额：
              <span class="c_red c-font-bold">¥ {{ compute.totalPrice }}</span>
              <span v-if="compute.preferentialAmount > 0">
                （原价：¥{{ compute.originPrice }}）
              </span>
            </div>
            <div v-if="order.openType == 'new'">
              <el-button type="primary" @click="placeOrder">下单</el-button>
              <el-button plain @click="initOrder">取消</el-button>
            </div>
          </div>
        </el-drawer>
        <!--选择订单产品-->
        <el-dialog
          title="产品类别"
          :visible.sync="product.open"
          class="c-dialog"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <div>
            <el-input
              placeholder="请输入产品名称/编号"
              v-model="product.searchValue"
              class="search-input c-fr"
              clearable
              @clear="
                product.fpi.page = 1;
                getProduct();
              "
              @keyup.enter.native="
                product.fpi.page = 1;
                getProduct();
              "
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="
                  product.fpi.page = 1;
                  getProduct();
                "
              ></el-button>
            </el-input>
          </div>
          <el-table
            :data="product.fpi.data"
            height="100%"
            style="width: 100%; min-height: 440px"
            fit
            header-row-class-name="c-black-dark"
            @selection-change="productSelect"
            empty-text="暂无未选择的产品"
          >
            <el-table-column type="selection" width="55" fixed></el-table-column>
            <el-table-column prop="name" label="产品名称" fixed></el-table-column>
            <el-table-column prop="code" label="编号"></el-table-column>
            <el-table-column prop="price" label="单价(元)"></el-table-column>
            <el-table-column prop="unit" label="单位" :formatter="formatUnit"></el-table-column>
            <el-table-column
              prop="productType"
              label="产品类别"
              :formatter="formatProductType"
            ></el-table-column>
            <el-table-column
              prop="description"
              label="描述"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
          <div slot="footer">
            <el-pagination
              class="pagination"
              @size-change="pageSizeChange"
              @current-change="pageChange"
              :current-page="product.fpi.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="product.fpi.rows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="product.fpi.total"
            ></el-pagination>
            <div>
              <el-button type="primary" @click="saveSelectProduct">确 定</el-button>
              <el-button @click="cancelSelectProduct">取 消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <!--关联/添加线索-->
    <el-drawer
      custom-class="c-drawer"
      title="添加线索"
      :visible.sync="lead.openRelate"
      direction="rtl"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <div class="el-drawer__content">
        <el-tabs v-model="lead.activeName" type="card">
          <!-- <el-tab-pane label="选择已有线索" name="search">
              <p class="c-m-b-10 c-font-13">请输入客户姓名/手机号进行搜索</p>
              <el-select
                v-model="formData.leadIds"
                filterable
                remote
                reserve-keyword
                placeholder
                :remote-method="getLead"
                clearable
                @clear="getLead"
                :loading="false"
                @change="$forceUpdate()"
                class="c-w-1"
              >
                <el-option
                  v-for="item in lead.data"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                >
                  <span class="c-fl">{{ item.name }}</span>
                  <span class="c-fr c-font-13">{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-tab-pane> -->
          <el-tab-pane label="新建客户" name="create">
            <el-form
              :model="lead.formData"
              :rules="rules"
              ref="leadFormData"
              label-width="90px"
              label-position="left"
              hide-required-asterisk
            >
              <el-form-item label="姓名" prop="name">
                <el-input v-model="lead.formData.name" suffix-icon="el-icon-user"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                <el-input
                  v-model="lead.formData.phone"
                  suffix-icon="el-icon-mobile-phone"
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="lead.formData.email" suffix-icon="el-icon-message"></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="address">
                <el-input
                  v-model="lead.formData.address"
                  suffix-icon="el-icon-map-location"
                ></el-input>
              </el-form-item>
              <el-form-item label="状态" prop="leadStatus">
                <el-select v-model="lead.formData.leadStatus">
                  <el-option
                    v-for="item in options.leadStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="阶段" prop="lifecycleStage">
                <el-select v-model="lead.formData.lifecycleStage">
                  <el-option
                    v-for="item in options.lifecycleStage"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="el-drawer__footer" v-if="lead.activeName == 'search'">
        <el-button type="primary" @click="saveLead()">保存</el-button>
        <el-button plain @click="initLead">取消</el-button>
      </div>
      <div class="el-drawer__footer" v-if="lead.activeName == 'create'">
        <el-button type="primary" @click="saveLead()">保存</el-button>
        <el-button plain @click="initLead">取消</el-button>
      </div>
    </el-drawer>
    <!--编辑客户-->
    <el-drawer
      custom-class="c-drawer"
      title="编辑线索"
      :visible.sync="lead.openEdit"
      direction="rtl"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <div class="el-drawer__content">
        <el-form
          :model="lead.formData"
          :rules="rules"
          ref="leadFormData"
          label-width="90px"
          label-position="left"
          hide-required-asterisk
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="lead.formData.name" suffix-icon="el-icon-user"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="lead.formData.phone" suffix-icon="el-icon-mobile-phone"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="lead.formData.email" suffix-icon="el-icon-message"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="lead.formData.address" suffix-icon="el-icon-map-location"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="leadStatus">
            <el-select v-model="lead.formData.leadStatus">
              <el-option
                v-for="item in options.leadStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="阶段" prop="lifecycleStage">
            <el-select v-model="lead.formData.lifecycleStage">
              <el-option
                v-for="item in options.lifecycleStage"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="el-drawer__footer">
        <el-button type="primary" @click="saveLead()">保存</el-button>
        <el-button plain @click="initLead()">取消</el-button>
      </div>
    </el-drawer>
    <el-dialog
      title="步骤信息"
      :visible.sync="stepDataOpen"
      style="font-size: 16px; line-height: 40px"
      id="stepDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <template v-if="stepDataOpen">
        <el-tabs
          v-model="stepTabAction"
          @tab-click="stepTabClick"
          v-if="stepDataOpen && !this.stepformTabs.length"
        >
          <el-tab-pane
            v-for="(tabItem, index) in stepTabs"
            :label="tabItem.nodeDef.name"
            :name="`${index}`"
            :key="index"
          >
            <span slot="label">
              {{ tabItem.nodeDef.name }}
              <el-tag
                size="mini"
                :type="tabItem.state == '10' ? 'success' : 'info'"
                :effect="tabItem.state == '10' ? 'dark' : 'light'"
              >
                {{ tabItem.state == '10' ? '已完成' : '未完成' }}
              </el-tag>
            </span>
          </el-tab-pane>
        </el-tabs>
        <el-tabs v-else v-model="stepTabAction" @tab-click="stepTabClick">
          <el-tab-pane
            v-for="(tabItem, index) in stepformTabs"
            :label="tabItem.formTitle"
            :name="`${index}`"
            :key="index"
          >
            <span slot="label">
              {{ tabItem.formTitle }}
            </span>
          </el-tab-pane>
        </el-tabs>
      </template>
      <div style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); background: #fff">
        <div v-for="(item, index) in stepData" :key="index" class="padding-LR-10">
          <div
            style="display: flex; justify-content: space-between"
            v-if="index == 0 && stepValueData.createTime"
          >
            <span>创建时间</span>
            <span class="stepFile">{{ stepValueData.createTime }}</span>
          </div>
          <div style="display: flex; justify-content: space-between" v-if="item.type == 'area'">
            <span>{{ item.nameDisp }}</span>
            <span>{{ formatArea(stepValueData[item.name]) }}</span>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-else-if="item.type == 'switch'"
          >
            <span>{{ item.nameDisp }}</span>
            <el-switch
              style="display: block"
              v-model="stepValueData[item.name]"
              active-color="#13ce66"
              active-value="1"
              inactive-value="0"
              disabled
            ></el-switch>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-else-if="item.type == 'scan'"
          >
            <span>{{ item.nameDisp }}</span>
            <el-button size="small" type="primary">上传</el-button>
            <el-upload class="stepFile" disabled v-if="false">
              <el-button size="small" type="primary">上传</el-button>
            </el-upload>
          </div>
          <div v-else-if="item.type == 'sort'">
            <div>{{ item.nameDisp }}</div>
            <div>
              <template v-for="sortItem in formatSort(stepValueData[item.name], item)">
                <div
                  v-for="(sortV, sortIndex) in sortItem.value"
                  class="sortTableItem-wrapper"
                  :key="sortIndex"
                >
                  <div
                    class="sortTableItem-item"
                    style="border-right: 1px solid #ebeef5; min-width: 100px"
                  >
                    {{ sortItem.key }}
                  </div>
                  <div class="sortTableItem-item">
                    {{ sortV }}
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div
            v-html="item.frontEndConfig && item.frontEndConfig.html"
            v-else-if="item.type == 'title'"
          >
            <span
              v-if="!(item.frontEndConfig && item.frontEndConfig.html)"
              style="font-weight: 600; font-size: 22px"
            >
              {{ item.nameDisp }}
            </span>
          </div>
          <div
            v-else-if="item.type == 'file'"
            style="display: flex; justify-content: space-between"
          >
            <div>{{ item.nameDisp }}</div>
            <div style="width: 60%" class="stepFile">
              <template v-for="(urlFile, urlIndex) in stepValueData[item.name]">
                <el-image
                  class="elImage"
                  :src="renderImage(urlFile)"
                  :preview-src-list="renderImageList(stepValueData[item.name])"
                  :key="urlIndex"
                ></el-image>
              </template>
            </div>
          </div>
          <div
            class="step-gap"
            v-else-if="item.type == 'gap'"
            v-html="item.frontEndConfig && item.frontEndConfig.html"
          ></div>
          <div
            v-else-if="item.type == 'image'"
            style="display: flex; justify-content: space-between"
          >
            <div>{{ item.nameDisp }}</div>
            <div v-for="(frontEndConfigList, index) in item.frontEndConfig.list" :key="index">
              <el-image
                class="elImage"
                :src="frontEndConfigList"
                :preview-src-list="item.frontEndConfig.list"
              ></el-image>
            </div>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-else-if="item.type == 'radio'"
          >
            <span>{{ item.nameDisp }}</span>
            <span class="stepFile">
              {{ codelabelFilter(stepValueData[item.name], item.valueOption) }}
            </span>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-else-if="item.type == 'addItem'"
          >
            <span>{{ item.nameDisp }}</span>
            <span class="stepFile">
              {{ codelabelFilter(stepValueData[item.name], item.valueOption) }}
            </span>
          </div>
          <div v-else-if="item.type == 'button'">
            <el-button
              :type="formatButton(item, 'buttonType')"
              style="width: 100%; background: #ee0a24"
              @click="formatButton(item, 'func', stepNode)"
            >
              {{ item.nameDisp }}
            </el-button>
          </div>
          <div
            style="display: flex; justify-content: space-between;"
            v-else-if="
              tenantId == '4551453470943235290' && item.name == 'identity' && stepNode.state == 0
            "
          >
            <span>{{ item.nameDisp }}</span>
            <!-- <span class="stepFile">{{stepValueData[item.name]}}</span> -->
            <el-input
              style="width: 50%"
              type="text"
              class="stepFile"
              v-model="stepValueData[item.name]"
              :placeholder="`请输入${item.nameDisp}`"
            ></el-input>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-else-if="
              item.type == 'text' &&
                stepTabs[stepTabAction] &&
                stepTabs[stepTabAction].state != '10' &&
                item.name == 'identity'
            "
          >
            <span>{{ item.nameDisp }}</span>
            <el-input
              style="width: 50%"
              type="text"
              class="stepFile"
              v-model="stepValueData[item.name]"
              :placeholder="`请输入${item.nameDisp}`"
            ></el-input>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-else-if="item.type == 'dialog'"
          >
            <span>{{ item.nameDisp }}</span>
            <span class="stepFile">{{ stepValueData[item.name] ? '已读' : '未读' }}</span>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-else-if="item.type == 'checkbox'"
          >
            <span>{{ item.nameDisp }}</span>
            <span class="stepFile">
              {{ codelabelFilter(stepValueData[item.name], item.valueOption) }}
            </span>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-else-if="item.type == 'select'"
          >
            <span>{{ item.nameDisp }}</span>
            <span class="stepFile">
              {{ codelabelFilter(stepValueData[item.name], item.valueOption) }}
            </span>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            v-else-if="item.type == 'bizSelect'"
          >
            <span>{{ item.nameDisp }}</span>
            <span class="stepFile">
              {{ codelabelFilter(stepValueData[item.name], item.name) }}
            </span>
          </div>
          <div style="display: flex; justify-content: space-between" v-else>
            <span>{{ item.nameDisp }}</span>
            <span class="stepFile">{{ stepValueData[item.name] }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="condition-card c-flex-end">
        <el-button
          size="small"
          type="primary"
          plain
          @click="openStepData(false)"
          v-if="
            stepNode.nodeDef &&
              stepNode.nodeDef.name &&
              stepNode.nodeDef.nodeType == 'repeat' &&
              stepNode.state == 0 &&
              stepNode.visible &&
              stepNode.addBtnShow &&
              osg.has('ServiceAppointment,processWorkflow')
          "
        >
          新增
        </el-button>
        <div v-else></div>
        <el-button
          size="small"
          type="primary"
          plain
          style="margin-right:10px;"
          @click="openStepData(true, stepNode.formDataId ? true : false)"
          v-if="
            stepNode.nodeDef &&
              stepNode.nodeDef.formDefId &&
              stepNode.state == 0 &&
              stepNode.visible &&
              osg.has('ServiceAppointment,processWorkflow')
          "
        >
          编辑
        </el-button>
        <el-button
          type="success"
          size="small"
          :disabled="!repeatComplateEnable"
          @click="executeProcess('complate')"
          v-if="
            stepNode.nodeDef &&
              stepNode.nodeDef.name &&
              stepNode.nodeDef.nodeType == 'repeat' &&
              stepNode.state == 0 &&
              stepNode.visible &&
              osg.has('ServiceAppointment,processWorkflow')
          "
        >
          完成{{ stepNode.nodeDef.name }}
        </el-button>
        <div v-else></div>
        <el-button @click="stepDataOpen = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 服务步骤操作表单 -->
    <el-dialog
      v-if="stepNode.nodeDef && stepNode.nodeDef.name"
      :title="stepNode.nodeDef.name"
      :visible.sync="openStepDataDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="stepDataFormData"
        :fields="stepData"
        :upload="upload"
        :area="area"
        :options="options"
        ref="form"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="saveStepForm">确 定</el-button>
        <el-button
          @click="
            openStepDataDetail = false;
            stepDataFormData = { exts: {} };
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area';
// import areaList from '../../resources/js/areaList';

export default {
  activated() {
    window.$this = this;
  },
  name: 'serviceAppointment',
  props: {
    serviceState: {
      type: String
    }
  },
  components: {
    bizStackTrace: () => import('../../components/bizStackTrace')
  },
  data() {
    return {
      id: null,
      tenantId: '',
      workflowNodeObj: { nodeDef: { formFieldIdsReadOnly: [] } }, //当前工作流节点
      defNodes: [],
      runNodes: [],
      collapse: false,
      formData: { exts: {}, gpsPoint: {} },
      fieldsObj: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      requestOptions: {},
      options: {
        channelId: [], //获客渠道id
        //客户
        codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        cascadeCode_LEADSTATUS: { codeId: 'LEADSTATUS' },
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' },
        //工单
        // codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        cascadeCode_channel: { codeId: 'channel' },
        codecfg_callResult: { codeId: 'callResult' },
        codecfg_middleCallResult: { codeId: 'middleCallResult' },
        //公司
        codecfg_companytype: { codeId: 'COMPANYTYPE' },
        codecfg_industry: { codeId: 'INDUSTRY' },
        //地址
        codecfg_addressType: { codeId: 'ADDRESSTYPE' },
        codecfg_locationType: { codeId: 'LOCATIONTYPE' },
        //产品
        codecfg_productType: { codeId: 'productType' },
        codecfg_unit: { codeId: 'UNIT' },
        codecfg_payState: { codeId: 'PAYSTATE' },
        //订单
        codecfg_discount: { codeId: 'discount' },
        subdistricts: [],
        subdistricts2: [],
        //合同
        codecfg_contractStatus: { codeId: 'contractStatus' }
      },
      rules: this.$util.rules,
      contact: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'search',
        searchObj: {} //搜索选中要关联的工单对象
      },
      // 合同列表
      contract: {
        relatedData: []
      },
      company: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'search'
      },
      address: {
        relatedData: [],
        openEdit: false,
        formData: {}
      },
      order: {
        relatedData: [],
        openEdit: false,
        openType: 'new',
        description: ''
      },
      compute: {
        items: [],
        otherAmount: 0,
        preferentialAmount: 0,
        originPrice: 0,
        totalPrice: 0
      },
      product: {
        fpi: {},
        searchValue: '',
        open: false,
        selectRows: []
      },
      //质保豆腐块
      warranty: {
        relatedData: []
      },
      //地址级联
      area: {
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        },
        options: this.osg.areaList
      },
      activeTab: 'log',
      stepList: [], //服务步骤列表
      stepData: [], //服务步骤查看表单
      stepValueData: {}, //服务步骤表单的value值
      stepDataOpen: false, //服务步骤表单弹窗
      stepTabs: [], //tab表头里面有子节点
      stepformTabs: [], //tab表头里面有多表单
      stepTabAction: '0',
      stepNode: {}, //当前服务步骤当前流程节点
      openStepDataDetail: false, // 服务步骤-操作表单弹窗
      stepDataFormData: { exts: {} }, //服务步骤-操作表单
      repeatComplateEnable: true, //多表单完成按钮判断禁用
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 异常日志
      exception: {
        exceptionMsg: '',
        exception: '',
        show: false,
        active: 'exceptionMsg'
      },
      // 笔记
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      // 跟进记录列表
      record: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: [],
        openRecord: false, // 跟进记录弹窗
        recordFormData: {}, //跟进记录表单-上
        SArecordFormData: { gpsPoint: {}, exts: {} }, //跟进记录表单-下（工单信息）
        callData: [], //跟进记录-通话记录
        openCallRecord: false //跟进记录-通话记录弹窗
      },
      // 通话记录
      callRecords: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // UD通话记录
      UDcallRecords: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 操作记录
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      afterSaleSA: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: { exts: {} },
        activeName: 'search',
        searchObj: {} //搜索选中要关联的工单对象
      },
      historyHide: [
        'serviceAppointIds',
        'contactsId',
        'province',
        'city',
        'district',
        'paidAmount',
        'settledCardinal',
        'totalAmount',
        'workflowId',
        'workflowNodeList',
        'orgId',
        'belongTo'
      ],
      extList: {},
      //处理工作流所需参数
      urlParams: {
        colName: '', //根据对象名称查询字段
        formDefId: '', //表单定义id
        formDataId: '', //表单数据id
        workflowNodeId: '', //节点id
        tenantId: '', //租户id
        userId: '', //用户id
        smodule: '', //模块
        sid: '' //模块id
      },
      loginAccount: {}, //当前登陆账号信息
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8'],
      lead: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'create'
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      addOderMmterials: false, //材料总额添加到产品总额上
      /**
       * 中间号
       */
      privateNumber: {
        show: false,
        phone: ''
      },
      isIncomingCall: '', //呼入的客户电话
      appKeyCode: '', //请求token
      XAToken: '' //cookie中的token
    };
  },
  computed: {
    //富文本编辑器对象
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },

  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },

  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.id = this.osg.param('id');
    // this.$util.cookie.deleteCookie('X-Auth-Token');
    // this.$util.cookie.deleteCookie('JSESSIONID');
    this.appKeyCode = this.$route.query.appKeyCode;
    if (typeof this.appKeyCode !== 'undefined') {
      this.$util.cookie.set(
        this.$util.cookieRelative.token,
        this.appKeyCode,
        this.$util.cookieRelative.tokenExpires
      );
    }
    console.log('loginAccount', sessionStorage['loginAccount']);
    this.loginAccount = this.osg.isJson(sessionStorage['loginAccount'])
      ? JSON.parse(sessionStorage['loginAccount'])
      : { roleIds: [] };
    this.tenantId = this.loginAccount.tenantId;

    this.osg.getFields('serviceAppointment', () => {
      this.getData(() => {
        //从列表点击打电话，自动调打电话接口和弹出弹窗
        const isCall = this.$route.query.isCall;
        if (isCall) {
          this.osg.sobot.selfCallOut(
            {
              callNum: this.formData.phone,
              bizType: 'ServiceAppointment',
              bizId: this.formData._id
            },
            this.callOutBack
          );
        }
      });
      this.getLog();
      this.getChannel();
    });
    this.getNote();
  },
  methods: {
    //获取token
    // getToken() {debugger
    //   var params = {
    //     appKeyCode: this.appKeyCode
    //   };
    //   this.osg.ajax(
    //     'i/sso/appKeyCode.do',
    //     params,
    //     res => {debugger
    //       let token = res['X-Auth-Token'];
    //         this.$util.cookie.set(
    //           this.$util.cookieRelative.token,
    //           token,
    //           this.$util.cookieRelative.tokenExpires
    //         );
    //         console.log(res,'getToken中请求的值')
    //     },
    //     { method: 'GET' },
    //     {
    //       noload: true
    //     }
    //   );
    // },

    formatCallResult(val) {
      return this.osg.codelabel('callResult', val);
    },
    formatMiddleCallResult(val) {
      return this.osg.codelabel('middleCallResult', val);
    },
    //查询客户
    querySearch(queryString, cb) {
      var params = {
        page: 1,
        rows: 10,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#or': queryString,
        'regex:phone|string#or': queryString
      };
      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          cb(res.data);
        },
        { noload: true }
      );
    },
    //选择客户
    handleSelect(item) {
      let contactIds = this.formData.contactIds || [];
      contactIds.push(item._id);
      // this.$set(this.formData, 'contactIds', contactIds);
      this.$set(this.formData, 'phone', item.phone);
      this.$set(this.formData, 'address', item.address);
    },
    //获取地理编码
    async getGeocode() {
      if (this.formData.area[0] && this.formData.area[1]) {
        var citys = await this.$util.getCity(this.formData.area[0]);
        var cityName = '';
        for (var city of citys) {
          if (city._id == this.formData.area[1]) {
            cityName = city.name;
            break;
          }
        }
        this.osg.geocode(cityName + this.formData.address, res => {
          this.formData.gpsPoint = {
            longitude: res.location.split(',')[0],
            latitude: res.location.split(',')[1]
          };
          this.$forceUpdate();
        });
      }
    },
    //获取表单详情
    getData(callback) {
      this.osg.ajax(
        `basic/serviceAppointment/queryById/${this.id}.do`,
        {},
        res => {
          this.isIncomingCall = res.data.serviceAppointment.phone;

          /*获取当前工作流节点*/
          if (res.data.workflowNode && res.data.workflowNode[res.data.workflowNode.length - 1]) {
            this.workflowNodeObj = res.data.workflowNode[res.data.workflowNode.length - 1];
            this.defNodes = this.$util.deepCopy(res.data.workflow.def.nodes);
            this.runNodes = this.$util.deepCopy(res.data.workflowNode.slice(1));
            this.stepList = res.data.workflowNode.slice(1); //不展示工作流第一项
            //返回带有子流程的节点
            let subflowsArr = [];
            this.stepList = this.stepList.map(item => {
              if (item.handlerIds && item.handlerIds.indexOf(this.loginAccount._id) != -1) {
                item.visible = true;
              }
              if (Array.isArray(item.nodeDef.userChoose)) {
                for (let i = 0; i < item.nodeDef.userChoose.length; i++) {
                  if (this.loginAccount.roleIds.includes(item.nodeDef.userChoose[i])) {
                    item.visible = true;
                    break;
                  }
                }
              }

              // 判断是否展示新增表单按钮
              if (item.nodeDef.exts && item.nodeDef.exts.addBtnShow == 2) {
                //不展示
                item.addBtnShow = false;
              } else {
                item.addBtnShow = true;
              }
              if (item.nodeDef.nodeType == 'subflows') subflowsArr.push(item);
              return item;
            });

            //步骤列表拼接带有子流程的节点
            subflowsArr.forEach(item => {
              this.getSubflows(item.nodeDef, item._id, dataArr => {
                this.stepList = this.$util.deepCopy(
                  this.stepList.concat(this.$util.deepCopy(dataArr))
                );
                //跟进工作流的nodeId 切割后面的随机串排序
                this.stepList.sort((q, n) => {
                  console.log(
                    new Date(q.nodeDef.createTime || q.createTime).valueOf(),
                    new Date(n.nodeDef.createTime || n.createTime).valueOf()
                  );
                  return (
                    new Date(q.nodeDef.createTime || q.createTime).valueOf() -
                    new Date(n.nodeDef.createTime || n.createTime).valueOf()
                  );
                });
                this.$forceUpdate();
              });
            });
          }

          /*渲染省市区*/
          var row = res.data.serviceAppointment;

          // 无手机号返回查看中间号按钮
          if (
            !row.phone &&
            (this.tenantId == '1340835581184723420' ||
              (this.osg.tenantConfig && this.osg.tenantConfig.privateNumber == 1))
          ) {
            this.privateNumber.show = true;
          }
          //解析json格式area
          if (this.$util.isJson(row.area)) {
            row.area = JSON.parse(row.area);
          }

          row.gpsPoint = row.gpsPoint || {};
          this.$util.renderExtField(this.extFields, row);
          this.formData = row;
          this.osg.getSubdistricts(this.formData.area, result => {
            this.options.subdistricts = result;
            this.$forceUpdate();
          });
          this.tabClick({ name: this.activeTab });
          if (this.tenantId == '4551453470943235290') {
            this.getWorkType(); //渲染工作类型
          }
          this.getContactData(null, row.contactIds);
          if (row.companyId) {
            this.getCompanyData(null, row.companyId);
          } else {
            this.company.relatedData = [];
          }
          this.getAddressData();
          this.getOrderData();
          this.getLead(row.leadIds[0]);
          this.getContract(); //获取关联的合同列表
          this.getWarranty(); //获取关联的质保列表

          //售后工单
          this.getWorkflowAlert();
          if (callback) callback();
        },
        { noload: true }
      );
    },
    doSave() {
      if (this.osg.validate()) {
        if (this.osg.isRepeatClick('doSA', 5000)) {
          return;
        }
        var params = this.formData;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        }
        // this.$util.saveExtField(this.extFields, params);
        // 自定义字段转换值
        this.$util.saveFormatExtField(this.extFields, params);
        this.osg.ajax(
          'basic/serviceAppointment/upsert.do',
          { data: JSON.stringify(params) },
          () => {
            this.osg.toast('保存成功！');
            this.getData();
          }
        );
      }
    },
    //处理工作流
    process(workflowNodeId, nodeFormDefId, nodeFormDataId, callback) {
      let params = {
        workflowNodeId, //当前节点运行时_id
        nodeFormDefId, //节点表单定义id formDefId
        nodeFormDataId, //关联子流程列表的节点无数据id
        smodule: 'serviceAppointment', //来源模块
        sid: this.id //工单id
      };
      this.osg.ajax(
        'workflow/process.do',
        params,
        () => {
          if (callback) callback();
        },
        { noload: true }
      );
    },
    /**
     * 切换tab页
     */
    tabClick(tab) {
      switch (tab.name) {
        case 'log':
          this.getLog();
          break;
        case 'notes':
          this.getNote();
          break;
        case 'record':
          this.getRecord();
          break;
        case 'callRecords':
          this.getCallRecords();
          break;
        case 'UDcallRecords':
          this.getUDCallRecords();
          break;
        case 'history':
          this.getHistory();
          break;
        default:
          return;
      }
    },
    /**
     * 日志
     */
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'serviceAppointment',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    //获取跟进记录
    getRecord() {
      var params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        bizType: 'ServiceAppointment',
        bizId: this.id
      };
      this.osg.ajax(
        'followingUpNote/query.do',
        params,
        res => {
          if (res.data) {
            this.record.fpi = res;
          }
        },
        {
          noload: true
        }
      );
    },
    //查看通话记录
    viewCallRecord(callId) {
      this.osg.ajax(
        'basic/sobot/queryByCallId.do',
        {
          callId
        },
        res => {
          if (res.data) {
            this.record.callData = res.data;
            this.record.openCallRecord = true;
          }
        },
        { noload: true }
      );
    },
    formatterCodelabel(cellValue, valueOption, type) {
      if (type == 'cascade' && cellValue && cellValue.indexOf(',') != -1) {
        let value = cellValue.split(',');
        if (Array.isArray(value)) {
          let result = '';
          for (let item of value) {
            result += this.orderCodelabel(valueOption, item) + '-';
          }
          return result.substring(0, result.length - 1); //删除最后字符
        }
      } else if (type == 'cascade' && valueOption) {
        return this.orderCodelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    orderCodelabel: function(codeType, codeValue) {
      var opts = this.options[codeType];
      opts = this.cascadeFlat(opts);
      if (opts) {
        for (var i = 0; i < opts.length; i++) {
          if (codeValue == opts[i].value) return opts[i].name;
        }
      }
      if (!codeValue) {
        return codeValue;
      } else {
        return '未知';
      }
    },
    cascadeFlat: function(source) {
      if (Array.isArray(source)) {
        let flatArr = [];
        let fn = function(source) {
          source.forEach(el => {
            flatArr.push(el);
            if (el.children && el.children.length > 0) fn(el.children);
          });
        };
        fn(source);
        return flatArr;
      } else {
        return source;
      }
    },
    formatProvince(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.county_list[cellValue];
    },
    /**
     * 智齿通话记录
     */
    getCallRecords() {
      this.callRecords.searchDate = this.callRecords.searchDate || [];
      this.osg.ajax(
        'basic/sobot/query.do',
        {
          bizId: this.id,
          bizType: 'ServiceAppointment',
          _all: '1',
          'regex:callerName|string#or': this.callRecords.searchValue,
          'regex:caller|string#or': this.callRecords.searchValue,
          'regex:callee|string#or': this.callRecords.searchValue,
          'gte:createTime|datetime#and': this.callRecords.searchDate[0],
          'lte:createTime|datetime#and': this.callRecords.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.callRecords.fpi = res;
        },
        { noload: true }
      );
    },
    /**
     * UD通话记录
     */

    getUDCallRecords() {
      // this.callRecords.searchDate = this.callRecords.searchDate || [];
      // var params = {};
      this.osg.ajax(
        'biz/ud/query.do',
        {
          // bizId: this.id,
          // bizType: 'ServiceAppointment',
          _all: '1',
          tenantId: '1340835581184723420',
          customer_number: this.isIncomingCall,
          serviceAppointmentId: this.id,
          // 'regex:callerName|string#or': this.callRecords.searchValue,
          // 'regex:caller|string#or': this.callRecords.searchValue,
          // 'regex:callee|string#or': this.callRecords.searchValue,
          // 'gte:createTime|datetime#and': this.callRecords.searchDate[0],
          // 'lte:createTime|datetime#and': this.callRecords.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.UDcallRecords.fpi = res;
        },
        { noload: true }
      );
    },

    /**
     * 操作记录
     */
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    supplementField: function({ sourceArr, value, idKey, nameKey }) {
      let name;
      //数组中 item为对象
      for (let i = 0, j = sourceArr.length; i < j; i++) {
        if (sourceArr[i][idKey] == value) {
          name = sourceArr[i][nameKey];
        }
      }
      return name;
    },
    getExtListById(extId) {
      let that = this;
      return new Promise(resolve => {
        if (!extId) {
          resolve([]);
          return;
        }
        if (this.extList[extId]) {
          resolve(this.extList[extId]);
          return;
        }
        this.osg.ajax(
          'biz/extField/query.do',
          {
            extId
          },
          res => {
            let list = res.data || [];
            that.extList[extId] = list;
            resolve(list);
          }
        );
      });
    },
    getFields() {
      this.osg.ajax(
        'biz/ext/queryByColName/serviceAppointment.do',
        {
          _all: '1'
        },
        res => {
          if (res.entity) {
            this.fields = res.entity.extFieldList;

            let fieldsObj = {};
            res.entity.extFieldList.map(item => {
              item.label = item.nameDisp;
              item.value = item.name;
              fieldsObj[item.name] = item;

              if (this.$util.isJson(item.frontEndConfig)) {
                item.frontEndConfig = JSON.parse(item.frontEndConfig);
              } else {
                item.frontEndConfig = {};
              }
              // 扩展字段支持配置是否不展示字段修改记录
              if (item.frontEndConfig.historyHide || item.type == 'file') {
                this.historyHide.push(item.name);
              }
            });
            this.options.fields = res.entity.extFieldList;
            this.fieldsObj = fieldsObj;
          }
        },
        {
          noload: true
        }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (cellValue) {
        if (this.$util.isJson(cellValue)) {
          cellValue = JSON.parse(cellValue);
        }
      }
      let field = this.fieldsObj[row.field];
      if (field && field.valueOption) {
        if (field.type == 'cascade') {
          if (field.frontEndConfig.multiple) {
            return this.osg.formatCascadeMultiple(field.valueOption, cellValue);
          } else {
            return this.osg.formatCascade(field.valueOption, cellValue);
          }
        } else {
          return this.osg.codelabel(field.valueOption, cellValue);
        }
      } else if (row.field == 'area' || (field && field.type == 'area')) {
        return this.formatArea(cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'serviceAppointment'
        },
        res => {
          res.map(item => {
            item.openNote = false;
          });
          this.noteData = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: 'serviceAppointment',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.openNote = false;
        this.getNote();
      });
    },
    //获取工作类型
    getWorkType() {
      let params = {
        page: 1,
        rows: 100,
        'is:state|integer#or': 1,
        'is:_id|string#or': this.formData.workType
      };
      this.osg.ajax(
        'biz/workType/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.workType = res.data;
        },
        { noload: true }
      );
    },
    // 关联客户
    newContact() {
      this.contact.openRelate = true;
      this.getContactData();
    },
    editContact(item) {
      this.contact.formData = item;
      this.contact.openEdit = true;
    },
    //获取合同
    getContract() {
      if (this.id) {
        var params = {
          page: 1,
          rows: 100,
          'is:serviceAppointmentId|string#and': this.id,
          sortField: 'createTime',
          sortOrder: 'desc'
        };
        this.osg.ajax(
          'basic/contract/query.do',
          params,
          res => {
            this.contract.relatedData = res.data;
            this.$forceUpdate();
          },
          { noload: true }
        );
      }
    },
    //获取关联的质保
    getWarranty() {
      if (this.id) {
        var params = {
          _all: 1,
          'is:sid|string#and': this.id,
          'in:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        };
        this.osg.ajax('document/queryWarranty.do', params, res => {
          this.warranty.relatedData = res.data;
        });
      }
    },
    //获取关联的客户
    getContactData(query, contactIds) {
      var params = {
        page: 1,
        rows: 10,
        'regex:name|string#or': query,
        'regex:phone|string#or': query,
        'in:_id|array#and': contactIds && contactIds.join(','),
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (contactIds && contactIds.length > 0) {
            this.contact.relatedData = res.data;
          } else {
            this.contact.data = res.data;
          }
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    saveContact() {
      if (this.osg.validate('contactFormData')) {
        this.osg.ajax('basic/contacts/upsert.do', this.contact.formData, res => {
          //将新创建的公司id保存到客户的companyIds字段
          if (this.formData.contactIds.indexOf(res.data._id) == -1) {
            this.formData.contactIds.push(res.data._id);
            this.doSave();
          }
          this.initContact();
        });
      }
    },
    removeContact(item) {
      this.osg.confirm(`删除与 "${item.name}" 的关联？`, () => {
        var contactIds = this.formData.contactIds;
        for (let i = 0; i < contactIds.length; i++) {
          if (item._id == contactIds[i]) {
            contactIds.splice(i, 1);
            this.doSave();
            return;
          }
        }
      });
    },
    initContact() {
      this.contact.openEdit = false;
      this.contact.openRelate = false;
      this.contact.formData = {};
      this.contact.activeName = 'search';
      this.$refs['contactFormData'].resetFields();
    },
    // 关联公司
    newCompany() {
      this.company.openRelate = true;
      this.getCompanyData();
    },
    editCompany(item) {
      this.company.formData = item;
      this.company.openEdit = true;
    },
    getCompanyData(query, companyId) {
      var params = {
        page: 1,
        rows: 10,
        'regex:title|string#or': query,
        'regex:name|string#or': query,
        'eq:_id|string#and': companyId,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/company/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (companyId) {
            this.company.relatedData = res.data;
          } else {
            this.company.data = res.data;
          }
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    saveCompany() {
      if (this.osg.validate('companyFormData')) {
        this.osg.ajax('basic/company/upsert.do', this.company.formData, res => {
          //将新创建的公司id保存到客户的companyIds字段
          if (this.formData.companyId != res.data._id) {
            this.formData.companyId = res.data._id;
            this.doSave();
          }
        });
      }
    },
    removeCompany(item) {
      this.osg.confirm(`删除与 "${item.name}" 的关联？`, () => {
        this.formData.companyId = '';
        this.doSave();
      });
    },
    initCompany() {
      this.company.openEdit = false;
      this.company.openRelate = false;
      this.company.formData = {};
      this.company.activeName = 'search';
      this.$refs['companyFormData'].resetFields();
    },
    //关联地址
    newAddress() {
      this.address.openEdit = true;
    },
    editAddress(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.address.formData = item;
      this.address.openEdit = true;
    },
    getAddressData() {
      var params = {
        page: 1,
        rows: 10,
        'eq:typeId|string#or': this.id,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/address/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.address.relatedData = res.data;
        },
        { noload: true }
      );
    },
    saveAddress() {
      if (this.osg.validate('addressFormData')) {
        var obj = this.address.formData;
        obj.area = obj.area || [];
        if (obj.area.length > 0) {
          obj.province = obj.area[0] || '';
          if (obj.area.length > 1) {
            obj.city = obj.area[1] || '';
            if (obj.area.length > 2) {
              obj.district = obj.area[2] || '';
            }
          }
        }
        delete obj.area;
        this.address.formData.typeId = this.id;
        this.osg.ajax('basic/address/upsert.do', this.address.formData, () => {
          this.getAddressData();
          this.initAddress();
        });
      }
    },
    removeAddress(item) {
      this.osg.confirm(`删除与 "${item.address}" 的关联？`, () => {
        item.typeId = '';
        this.osg.ajax('basic/address/upsert.do', item, () => {
          this.getAddressData();
          this.initAddress();
        });
      });
    },
    initAddress() {
      this.address.openEdit = false;
      this.address.formData = {};
      this.address.activeName = 'search';
      this.$refs['addressFormData'].resetFields();
    },
    //关联订单
    newOrder() {
      this.formData.contactIds = this.formData.contactIds || [];
      if (this.formData.contactIds.length == 0) {
        this.osg.toast('工单至少需要添加1个客户，才可以下单！');
        return;
      }
      this.order.openType = 'new';
      this.compute = {
        items: [],
        otherAmount: 0,
        preferentialAmount: 0,
        originPrice: 0,
        totalPrice: 0
      };
      this.order.openEdit = true;
    },
    editOrder(item) {
      this.order.openType = 'view';
      //   this.compute.items = JSON.parse(item.productIds);
      this.compute.items = [];
      let newOrder = [];
      let originalOrder = [];

      item.productsDetail.forEach(el => {
        if (!this.addOderMmterials && Array.isArray(el.product.materials)) {
          //材料总计，将材料总计加到产品金额上
          let totalMaterials = el.product.materials
            .map(mItem => {
              return this.amountToFixed(
                this.amountToFixed(mItem.material.price) * this.amountToFixed(mItem.consumption)
              );
            })
            .reduce((q, n) => q + n, 0);
          // console.log(totalMaterials);
          el.product.price =
            this.amountToFixed(el.product.price) + this.amountToFixed(totalMaterials);
        }
        if (el.product.exts && el.product.exts.laterItem) {
          //   this.newOrder.productsDetail.push(el);
          newOrder.push(el);
        } else {
          //   this.originalOrder.productsDetail.push(el);
          originalOrder.push(el);
        }
      });

      this.compute.items = newOrder
        .map(oItem => {
          oItem.product.number = oItem.number;
          return oItem.product;
        })
        .concat(
          originalOrder.map(oItem => {
            oItem.product.number = oItem.number;
            return oItem.product;
          })
        );

      this.compute.otherAmount = item.otherAmount;
      this.compute.preferentialAmount = item.preferentialAmount;
      this.compute.originPrice = item.originPrice;
      this.compute.totalPrice = item.totalPrice;
      this.compute.discount = item.discount.toString();

      this.order.description = item.description;
      this.order.openEdit = true;
      if (!this.addOderMmterials) this.addOderMmterials = true;
    },
    //保留两位小数的金额
    amountToFixed(money) {
      if (!money) return 0;
      let resultAmount = +(+money).toFixed(2);
      return resultAmount ? resultAmount : 0;
    },
    getOrderData() {
      var params = {
        page: 1,
        rows: 100,
        serviceAppointmentId: this.formData._id,
        sortField: 'createTime',
        sortOrder: 'desc',
        'in:type|integer#and': '1',
        'in:state|integer#and': '1'
      };
      this.osg.ajax(
        'basic/order/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.order.relatedData = res.data;
        },
        { noload: true }
      );
    },
    placeOrder() {
      this.compute.items.map(item => {
        delete item.image;
      });
      let params = {
        productIds: JSON.stringify(this.compute.items), //产品和数量
        otherAmount: this.compute.otherAmount, //其他金额
        preferentialAmount: this.compute.preferentialAmount, //优惠金额
        totalPrice: this.compute.totalPrice, //总价
        description: this.order.description, //备注
        payState: 0, //支付状态
        ownerName: this.formData.name, //归属人姓名
        ownerPhone: this.formData.phone, //归属人电话
        contactId: this.formData.contactIds[0], //客户id
        serviceAppointmentId: this.formData._id //工单id
      };
      this.osg.ajax('basic/order/upsert.do', params, () => {
        this.getOrderData();
        this.initOrder();
        this.osg.toast('下单成功');
      });
    },
    initOrder() {
      this.order.openEdit = false;
      this.compute = {
        items: [],
        otherAmount: 0,
        preferentialAmount: 0,
        originPrice: 0,
        totalPrice: 0
      };
    },
    pageSizeChange(pageSize) {
      this.product.fpi.rows = pageSize;
      this.getProduct();
    },
    pageChange(currentPage) {
      this.product.fpi.page = currentPage;
      this.getProduct();
    },
    getProduct() {
      let selectIds = [];
      for (let item of this.compute.items) {
        selectIds.push(item._id);
      }
      let params = {
        page: this.product.fpi.page,
        rows: this.product.fpi.rows,
        'regex:name|string#or': this.product.searchValue,
        'regex:code|string#or': this.product.searchValue,
        'nin:_id|string#and': selectIds,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/product/query.do',
        params,
        res => {
          this.product.fpi = res;
          this.product.open = true;
        },
        { noload: true }
      );
    },
    productSelect(val) {
      this.product.selectRows = val;
    },
    saveSelectProduct() {
      let that = this;
      that.product.selectRows.map(item => {
        item.number = 0;
      });
      this.compute.items = this.compute.items.concat(that.$util.deepCopy(that.product.selectRows));
      this.product.open = false;
    },
    cancelSelectProduct() {
      this.product.selectRows = [];
      this.product.open = false;
    },
    removeItem(index) {
      this.compute.items.splice(index, 1);
    },
    //查看服务步骤
    seeSteps(step, tabAction, nodeType) {
      //如果是子流程且传来的参数没有formDataId/formDefId，则默认打开第一个表单
      let _formDataId =
        step.formDataId ||
        (step.nodeDef.workflowNodeList && step.nodeDef.workflowNodeList[0].nodeDef.formDataId);
      //如果子流程state是0则取nodeDef里的formDefId
      let isDone = step.state == 0 || !step.nodeDef.workflowNodeList;
      let _formDefId =
        step.formDefId || isDone
          ? step.nodeDef.formDefId
          : step.nodeDef.workflowNodeList[0].nodeDef.formDefId;
      //服务步骤点击tab切换则不重置tabList数据
      if (!tabAction) {
        //默认打开第一个
        this.stepTabAction = '0';
        this.stepformTabs = [];
        //第一次打开页面给表单弹窗tabs赋值
        let stepTabs =
          step.nodeDef && step.nodeDef.workflowNodeList ? step.nodeDef.workflowNodeList : [];
        this.stepTabs = stepTabs;

        //由于带有子流程第一次进来没有formDataId，需要重新获取
        let row = this.stepTabs[this.stepTabAction];
        _formDataId = _formDataId
          ? _formDataId
          : (row && row.formDataId) ||
            (row &&
              row.nodeDef.workflowNodeList &&
              row.nodeDef.workflowNodeList[0].nodeDef.formDataId);
      }
      //一个节点多表单类型，取formDefId
      if (nodeType == 'repeat') _formDefId = _formDataId = step.nodeDef.formDefId;
      //   渲染步骤表单
      this.renderStepForm(_formDefId, _formDataId, nodeType);
    },
    //渲染步骤表单
    renderStepForm(_formDefId, _formDataId, nodeType) {
      this.getExtField(_formDefId).then(() => {
        // //更新字典表数据
        // for (let opVal of _valueOptionArr) {
        //   this.options[`codecfg_${opVal}`] = { codeId: opVal };
        // }
        this.osg.codeoption(() => {
          this.getExtForm(
            _formDefId,
            _formDataId,
            nodeType == 'repeat'
              ? { 'is:workflowId|string#and': this.formData.workflowId }
              : { 'is:_id|string#and': _formDataId },
            nodeType
          );
        });
        this.stepDataOpen = true;
      });
    },
    getExtForm(formDefId, formDataId, param, nodeType) {
      let params = Object.assign({ sortField: 'createTime', sortOrder: 'desc' }, param);
      return new Promise(resolve => {
        this.osg.ajax(
          'biz/extForm/query/' + formDefId + '.do',
          params,
          res => {
            //有值才展示表单value值
            if (formDataId) {
              if (nodeType == 'repeat') {
                this.stepformTabs = res.data || [];
                this.stepValueData = res.data[this.stepTabAction] || {};

                // repeat节点 有表单未填写，不允许完成当前节点
                let repeatComplateEnable = true;
                if (res.data.length == 0) {
                  repeatComplateEnable = false;
                } else {
                  for (let item of res.data) {
                    if (item.nodeId != this.stepNode._id) {
                      repeatComplateEnable = false;
                      break;
                    }
                  }
                }
                //多表单完成按钮判断禁用
                this.repeatComplateEnable = repeatComplateEnable;
              } else {
                this.stepValueData = res.data[0] || {};
              }
            } else {
              this.stepValueData = {};
            }
            resolve();
          },
          {
            noload: true
          }
        );
      });
    },
    getExtField(formDefId) {
      return new Promise(resolve => {
        if (!formDefId) {
          resolve([]);
        } else {
          this.osg.ajax(
            'biz/extField/query.do',
            {
              extId: formDefId,
              sortField: 'order',
              'in:state|array-integer#and': '1',
              _all: '1'
            },
            res => {
              let valueOptionArr = [];
              if (formDefId) {
                this.stepData = res.data.map(item => {
                  if (!item.showList) {
                    item.showList = ['2'];
                  } else if (item.showList.indexOf('2') == -1) {
                    item.showList.push('2');
                  }
                  //解析字段配置
                  if (this.$util.isJson(item.frontEndConfig)) {
                    item.frontEndConfig = JSON.parse(item.frontEndConfig);
                  } else {
                    item.frontEndConfig = {};
                  }
                  //更新字典表
                  if (item.valueOption) {
                    this.options['codecfg_' + item.valueOption] = {
                      codeId: item.valueOption
                    };
                  }
                  //如果字段配置了options，更新字典表
                  if (item.frontEndConfig && item.frontEndConfig.options) {
                    this.options['codecfg_' + item.frontEndConfig.options] = {
                      codeId: item.frontEndConfig.options
                    };
                  }
                  //级联
                  if (item.type == 'cascade')
                    this.options['cascadeCode_' + item.valueOption] = {
                      codeId: item.valueOption
                    };
                  //给业务档案类型的对象添加otions字典表
                  if (item.type == 'bizSelect' && item.frontEndConfig.requestUrl)
                    this.bizSelectSetOptions(item.name, item.frontEndConfig);

                  //将只读的必填去掉,加上只读的css
                  if (this.stepNode.nodeDef && this.stepNode.nodeDef.formFieldIdsReadOnly) {
                    if (this.stepNode.nodeDef.formFieldIdsReadOnly.indexOf(item._id) != -1) {
                      item.required = '0';
                      item.class = 'c-pointer-n c_orange';
                      item.operationType = '2';
                    }
                  }
                  return item;
                });
                //将需要字典表的扩展字段收集为数组返回
                // for (let op of res.data) {
                //   if (op.valueOption) valueOptionArr.push(op.valueOption);
                //   if (op.frontEndConfig) {
                //     let keyOptions = JSON.parse(op.frontEndConfig).keyOptions;
                //     let options = JSON.parse(op.frontEndConfig).options;
                //     if (keyOptions) valueOptionArr.push(keyOptions);
                //     if (options) {
                //       valueOptionArr.push(options);
                //     }
                //   }
                // }
              }
              resolve(valueOptionArr);
            },
            {
              noload: true
            }
          );
        }
      });
    },
    //业务档案对象下拉
    bizSelectSetOptions(field, frontEndConfig) {
      frontEndConfig.requestUrl =
        frontEndConfig.requestUrl.indexOf('.do') != -1
          ? frontEndConfig.requestUrl
          : frontEndConfig.requestUrl + '.do';
      this.osg.ajax(
        frontEndConfig.requestUrl,
        {
          page: 1,
          rows: 100,
          'in:state|array-integer#and': '1'
        },
        res => {
          res.data.map(item => {
            item.label = item[frontEndConfig.label];
            item.value = item[frontEndConfig.value];
          });
          this.options[field] = res.data;
        }
      );
    },
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('unit', cellValue);
    },
    formatProductType(row, column, cellValue) {
      return this.osg.codelabel('productType', cellValue);
    },
    formatPayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    //反显服务步骤省市区
    formatArea(arr) {
      if (!arr) return;
      let str = '';
      if (arr[0]) str += this.osg.areaObj.province_list[arr[0]];
      if (arr[1]) str += this.osg.areaObj.city_list[arr[1]];
      if (arr[2]) str += this.osg.areaObj.county_list[arr[2]];
      return str;
    },
    //反显服务步骤产品sort类型
    formatSort(data, row) {
      if (data && row) {
        let options = row.frontEndConfig ? row.frontEndConfig.options : null;
        let sortArr = [];
        for (let i in data) {
          sortArr.push({
            key: options ? this.codelabelFilter(i, options) : i,
            value: data[i]
          });
        }
        return sortArr;
      }
    },
    //反显服务步骤的按钮类型
    formatButton(data, type, stepNode) {
      let frontEndConfig = this.osg.isJson(data.frontEndConfig)
        ? JSON.parse(data.frontEndConfig)
        : data.frontEndConfig || {};
      if (type == 'buttonType') {
        return frontEndConfig.type;
      } else if (type == 'func') {
        let funcName = frontEndConfig.func;
        if (funcName) this[funcName](frontEndConfig, stepNode); //saveFormData
      }
    },
    //反显字典表，支持类型传数组
    codelabelFilter(value, ops) {
      if (Array.isArray(value)) {
        let result = '';
        for (let item of value) {
          result += ' ' + this.osg.codelabel(ops, item);
        }
        return result;
      } else {
        return this.osg.codelabel(ops, value);
      }
    },
    /**
     * 查询节点的子流程列表
     */
    getSubflows(nodeDef, parentNodeId, callback) {
      this.osg.ajax(
        `workflow/queryByParentWorkflowNodeId/${parentNodeId}.do`,
        {
          'ne:state|integer#and': '-1'
        },
        res => {
          if (callback) {
            //父流程嵌套子流程数据，方便渲染页面
            let nodeDefList = [];
            res.data.map(node => {
              let _nodeDef = Object.assign({}, nodeDef); //防止栈内容导致始终push最后一个
              _nodeDef.nodeDef = node;
              nodeDefList.push(_nodeDef);
            });
            callback(nodeDefList);
          }
        },
        {
          noload: true
        }
      );
    },
    //服务步骤弹窗内的tab切换点击
    stepTabClick() {
      if (this.stepformTabs.length) {
        //渲染步骤表单
        this.stepValueData = this.stepformTabs[this.stepTabAction];
      } else {
        let row = this.stepTabs[this.stepTabAction];
        this.seeSteps(row, true);
      }
    },
    //保存服务步骤操作表单
    saveStepForm() {
      if (this.osg.validate('formdaisamdsoidmaoisdoia')) {
        if (this.osg.isRepeatClick('saveStepForm', 5000)) {
          return;
        }
        let temp = {
          sid: this.id,
          smodule: 'serviceAppointment',
          workflowId: this.stepNode.workflowId,
          nodeId: this.stepNode._id
        };
        //将exts里的放到外层
        let params = Object.assign(this.stepDataFormData, this.stepDataFormData.exts, temp);
        delete params.exts;
        if (this.stepNode.nodeDef.nodeType == 'repeat') {
          // delete params._id;
          if (this.stepData[0] && this.stepData[0].name) {
            params.formTitle = params.formTitle || params[this.stepData[0].name];
          }
        }
        let nodeFormDefId = this.stepNode.nodeDef.formDefId;
        // 保存表单
        this.osg.ajax(
          `biz/extForm/upsert/${nodeFormDefId}.do`,
          {
            dataStr: JSON.stringify(params)
          },
          res => {
            this.process(this.stepNode._id, nodeFormDefId, res.data._id, () => {
              this.getData();
              this.openStepDataDetail = false;
              this.stepDataFormData = { exts: {} };
              this.stepDataOpen = false;
              this.osg.toast('操作成功！');
            });
          },
          {
            noload: true
          }
        );
      }
    },
    //激活质保单按钮
    saveFormData(frontEndConfig, stepNode) {
      let currentNode = stepNode || this.stepTabs[this.stepTabAction];
      if (currentNode.state == 10) {
        this.osg.alert('已完成，请勿重复提交！');
        return;
      }
      this.loginAccount = JSON.parse(sessionStorage.getItem('loginAccount'));
      this.urlParams = {
        colName: 'serviceAppointment', //根据对象名称查询字段
        formDefId: currentNode.state == 0 ? currentNode.nodeDef.formDefId : currentNode.formDefId, //表单定义id
        formDataId: currentNode.formDataId, //表单数据id
        workflowNodeId: currentNode._id, //节点id
        tenantId: this.loginAccount.tenantId, //租户id
        userId: this.loginAccount._id, //用户id
        smodule: 'serviceAppointment', //模块
        sid: this.id //模块id
      };
      this.urlParams = Object.assign(this.urlParams, this.stepValueData);
      let identityReg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      if (!identityReg.test(this.urlParams.identity)) {
        this.osg.alert('证件编号格式有误！');
        return;
      }
      this.osg.ajax(
        `biz/extForm/upsert/${this.urlParams.formDefId}.do`,
        {
          dataStr: JSON.stringify(this.urlParams)
        },
        () => {
          this.stepProcess(frontEndConfig.success, () => {
            //节点执行完毕将状态改为10，防止重复点击
            currentNode.state = 10;
          });
        },
        {
          noload: true
        }
      );
    },
    newLead() {
      this.lead.openRelate = true;
    },
    initLead() {
      this.lead.searchObj = {};
      this.lead.openEdit = false;
      this.lead.openRelate = false;
      this.lead.formData = {};
      this.lead.activeName = 'search';
      this.$refs['leadFormData'].resetFields();
      this.getLead(this.id);
    },
    getLead(leadIds) {
      var params = {
        page: 1,
        rows: 10,
        'in:_id|string#and': leadIds,
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      this.osg.ajax(
        'basic/lead/query.do',
        params,
        res => {
          if (leadIds && leadIds.length > 0) {
            this.lead.relatedData = res.data;
          } else {
            this.lead.data = res.data;
            if (this.lead && !this.lead.length) this.lead.relatedData = [];
          }
        },
        { noload: true }
      );
    },
    editLead(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.address.formData = item;
      this.address.openEdit = true;
    },
    saveLead() {
      // //将的客户id保存到新创建的线索的contactsIds字段
      this.lead.formData.contactsIds = this.lead.formData.contactsIds || [];
      this.lead.formData.contactsIds.push(this.id);
      if (this.osg.validate('leadFormData')) {
        this.osg.ajax('basic/lead/upsert.do', { data: JSON.stringify(this.lead.formData) }, () => {
          this.osg.toast('操作成功！');
          this.initLead();
        });
      }
    },
    //处理工作流节点(在服务步骤调用)，没有拦截器的处理工作流接口
    stepProcess(mesaage, callback) {
      let params = {
        workflowNodeId: this.urlParams.workflowNodeId,
        nodeFormDefId: this.urlParams.formDefId,
        nodeFormDataId: this.urlParams.formDataId,
        smodule: this.urlParams.smodule || 'serviceAppointment',
        tenantId: this.urlParams.tenantId,
        userId: this.urlParams.userId,
        context: this.loginAccount.orgIds
      };
      this.osg.ajax('/s/processWorkflow.do', params, () => {
        this.osg.alert(mesaage, () => {
          if (callback) callback();
        });
      });
    },
    /**
     * 外呼
     */
    callOut() {
      // 调用外呼接口-传外呼号码
      this.osg.sobot.callOut({
        destinationNumber: this.formData.phone,
        params: `{ "bizType": "ServiceAppointment","bizId":"${this.formData._id}"}`
      });
      // 打开笔记
      this.activeTab = 'notes';
      this.openNote = true;
    },
    //外呼回调
    callOutBack() {
      // 打开笔记
      this.activeTab = 'notes';
      this.openNote = true;
    },
    //用于扩展字段，判断如果配置了因为某个字段值才显示
    isShowField(obj, key, showField, showValue) {
      if (
        obj[showField] &&
        (obj[showField] == showValue || Array.isArray(obj[showField])
          ? obj[showField].flat().indexOf(showValue) !== -1
          : obj[showField].indexOf(showValue) !== -1)
      )
        return true;

      obj.exts = obj.exts || {};
      if (
        obj.exts[showField] &&
        (obj.exts[showField] == showValue || Array.isArray(obj.exts[showField])
          ? obj.exts[showField].flat().indexOf(showValue) !== -1
          : obj.exts[showField].indexOf(showValue) !== -1)
      )
        return true;
    },
    //获取售后工单
    getWorkflowAlert() {
      var params = {
        'is:type1Type|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1',
        'in:exts.sid|array#and': this.id
      };
      //添加过滤器参数
      //   $that.getParams(params);
      this.osg.ajax('biz/workflowAlert/query.do', params, res => {
        this.afterSaleSA.relatedData = res.data;
      });
    },
    getChannel() {
      this.osg.ajax(
        'channel/query.do',
        {
          _all: '1',
          'is:state|integer#and': '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.channelId = res.data;
          this.$forceUpdate();
        }
      );
    },
    //打开服务步骤操作表单
    openStepData(isEdit, formDataId) {
      if (formDataId) {
        // 编辑未处理节点关联表单数据
        if (this.stepValueData) {
          this.stepDataFormData = this.stepValueData;
          this.stepDataFormData.exts = this.stepDataFormData.exts || {};
        } else {
          this.stepDataFormData = { exts: {} };
        }
        this.openStepDataDetail = true;
        return;
      }

      if (isEdit) {
        this.stepDataFormData.exts = this.$util.deepCopy(this.stepValueData) || {};
        let deleteKeys = [
          'belongTo',
          'createTime',
          'createUser',
          'formTitle',
          'nodeId',
          'orgId',
          'smodule',
          'tenantId',
          'updateTime',
          'updateUser',
          'workflowId',
          '_id'
        ];
        for (let key of deleteKeys) {
          this.stepDataFormData[key] = this.stepValueData[key];
          delete this.stepDataFormData.exts[key];
        }
        this.$util.renderExtField(this.stepData, this.stepDataFormData);
      } else {
        this.stepDataFormData = { exts: {} };
      }
      this.openStepDataDetail = true;
    },
    //完成流程节点
    executeProcess(params) {
      if (this.osg.isRepeatClick('executeProcess', 10000)) {
        return;
      }
      // params:  1.complate处理多表单会用到
      if (params == 'complate') {
        if (this.stepNode.nodeDef.nodeType == 'repeat') {
          if (!this.stepformTabs || this.stepformTabs.length == 0) {
            this.osg.toast('请至少填写1份表单！', 'warning');
            return;
          }
        }
        this.osg.confirm(`确定要完成${this.stepNode.nodeDef.name}吗？`, () => {
          // console.log(this.stepformTabs, '///');
          // console.log(this.stepNode);
          // 1.workflowNodeId(当前节点运行时_id); 2.nodeFormDefId(节点表单定义id);3.nodeFormDataId(关联子流程列表的节点无数据id)
          //处理工作流
          this.process(this.stepNode._id, this.stepNode.nodeDef.formDefId, '', () => {
            this.getData();
            this.stepDataOpen = false;
            this.osg.toast('操作成功！');
          });
        });
      }
    },
    // 渲染图片
    renderImage(urlData) {
      if (urlData.response && urlData.response.key) {
        return this.osg.downloadUrl + urlData.response.key.replace(this.osg.downloadUrl, '');
      } else if (urlData.url) {
        return urlData.url;
      }
    },
    //渲染图片预览列表
    renderImageList(value) {
      let res = value.map(urlData => {
        if (urlData.response && urlData.response.key) {
          return this.osg.downloadUrl + urlData.response.key.replace(this.osg.downloadUrl, '');
        } else if (urlData.url) {
          return urlData.url;
        }
      });
      return res;
    },
    //获取质保卡库存
    getWarrantyProductInventorys(phone) {
      if (phone.length == '11') {
        var params = {
          // page: 1,
          // rows: 50,
          _all: 1,
          'is:status|integer#and': '3',
          'is:state|integer#and': '1',
          'is:customerPhone|string#and': phone
          // sortField: 'createTime',
          // sortOrder: 'desc',
          // notFilterOrgId: '1',
          // notFilterBelongTo: '1'
        };
        this.osg.ajax('basic/warrantyProductInventory/query.do', params, res => {
          if (res.data) {
            this.$set(
              this.options,
              'warrantyProductInventorys',
              res.data.map(item => {
                item.label = item.warrantyProductName;
                item.name = item.warrantyProductName;
                item.value = item._id;
                return item;
              })
            );
            this.$forceUpdate();
          }
        });
      } else {
        this.$set(this.options, 'warrantyProductInventorys', []);
      }
    },
    //选择质保卡
    handleInventoryIdSelect(value) {
      let row = this.options.warrantyProductInventorys.find(item => item._id == value);
      //选择字典表选项
      this.formData.exts['inventoryId'] = row.value; //质保卡库存id
      this.formData.exts['inventoryCode'] = row.inventoryCode; //质保卡库存编号
      this.formData.exts['warrantyProductName'] = row.warrantyProductName; //质保卡库存名称
      this.formData.exts['wpiOrgId'] = row.orgId; //质保卡关联的orgid

      this.formData['area'] = row.exts.area; //省市区
      if (row.exts.area.length >= 1) {
        this.formData.province = row.exts.area[0];
      }
      if (row.exts.area.length >= 2) {
        this.formData.city = row.exts.area[1];
      }
      if (row.exts.area.length >= 3) {
        this.formData.district = row.exts.area[2];
      }

      this.formData['address'] = row.exts.address; //详细地址
      this.formData['applyTime'] = row.exts.applyTime; //预约时间
      this.formData.exts['certificateType'] = row.exts.certificateType; //证件类型
      this.formData.exts['certificateNum'] = row.exts.certificateNum; //证件号
      this.formData.exts['warrantyProductProductList'] = row.exts.warrantyProductProductList; //激活质保卡库存选择的防水产品
    },
    //修补施工小流程
    patchingWorkflow(name) {
      this.osg.ajax(`basic/serviceAppointment/${name}/${this.formData._id}.do`, null, () => {
        this.osg.toast('操作成功！');
      });
    }
  },

  watch: {
    'contact.activeName'() {
      if (this.contact.activeName == 'create') this.getData();
    },
    // compute: {
    //   handler(computeObj, oblVal) {
    //     console.log(computeObj);
    //     //TODO:这个计算有bug，每次打开总金额都会增加，如果要使用，请修复 XD
    //     let totalPrice = 0;
    //     for (let item of computeObj.items) {
    //       totalPrice = this.amountToFixed(
    //         totalPrice +
    //           this.amountToFixed(
    //             this.amountToFixed(item.price) * this.amountToFixed(item.number || 0)
    //           )
    //       );
    //     }
    //     totalPrice = this.amountToFixed(totalPrice + this.compute.otherAmount || 0);
    //     this.compute.originPrice = totalPrice;
    //     totalPrice = this.amountToFixed(totalPrice - this.compute.preferentialAmount || 0);
    //     console.log(totalPrice);
    //     this.compute.totalPrice = totalPrice;
    //   },
    //   deep: true
    // },
    //area 级联组件点击label就消失
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //手机号发生改变
    'formData.phone'(val) {
      if (this.tenantId == '4551453470943235290') this.getWarrantyProductInventorys(val);
    }
  }
};
</script>
<style>
.el-image-viewer__wrapper {
  z-index: 5000 !important;
}
#app .activity-card-footer {
  padding-left: 30px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.sortTableItem-wrapper {
  border: 1px solid #ebeef5;
  border-bottom: none;
  box-sizing: border-box;
  vertical-align: middle;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
}
.sortTableItem-wrapper:last-of-type {
  border-bottom: 1px solid #ebeef5;
}
.sortTableItem-item {
  border-bottom: none;
  box-sizing: border-box;
  vertical-align: middle;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  align-items: center;
}
.step-gap {
  background: #f5f8fa;
  min-height: 10px;
  border-radius: 2px;
  margin: 20px 0;
}
.stepFile {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.stepFile input {
  text-align: right;
}
.padding-LR-10 > div {
  padding: 0 10px;
}
#stepDialog .el-dialog__body {
  flex: 1;
  padding: 20px 50px;
  overflow-y: auto;
  background: #f5f8fa;
  display: flex;
  flex-direction: column;
}
#stepDialog .el-tabs__content {
  display: none;
}
#stepDialog .elImage {
  width: 100px;
  height: 100px;
  border: 1px solid #dcdfe6;
  padding: 8px;
  margin: 4px;
}
/* 处理input type = number的上下箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}

#app .exception .el-dialog {
  width: 1000px !important;
  margin: 20vh auto 20vh !important;
  height: 60vh;
}
.sa .steps-13 .el-step.is-simple .el-step__title {
  font-size: 13px;
}
</style>
<style lang="scss" scoped>
.box-left-content .el-input-group__append {
  background: #409eff;
  border-color: #409eff;
  .el-icon-phone {
    color: #fff;
  }
}
.box-detail {
  flex: 1;
  background: #fff;
  border-radius: 5px;
}
</style>
<style>
.sa {
  background: #f2f2f2;
  padding: 0;
}
.sa .steps {
  margin: 0 0 10px 0px;
  padding: 10px 3%;
  border-radius: 5px;
  background: #fff;
  overflow-x: auto;
}
.sa .steps .el-step__title {
  white-space: nowrap;
}
.sa .steps .el-step__arrow {
  margin: 0 20px;
}
</style>
